document.addEventListener("DOMContentLoaded", (event) => {

  /* REMOVED (2026-07-31): setVhUnit() wrote window.innerHeight * 0.01 into a --vh custom
     property on every resize, but NOTHING in the theme ever read var(--vh) — verified with a
     theme-wide grep before deleting. On iOS it re-fired on every URL-bar collapse mid-scroll,
     doing a layout read and a style write per event for no effect. */

  
  document.documentElement.style.setProperty("--top-menu-height", document.querySelector('.shopify-section--header').offsetHeight + 'px');

    /* =======================================================================
  ======== Mega menu show script on mouseover over the top level menu ======= */
  const topLinks = document.querySelectorAll('.top-menu--link');
  const topSimpleLinks = document.querySelectorAll('.top-menu--link:not(.has-children)');
  const megaMenus = document.querySelectorAll('.top-menu--megamenu.sss');
  const megaMenuBoxs = document.querySelectorAll('.top-menu--megmamenu-container');
  
  topLinks.forEach(link => {
    link.addEventListener("mouseover", function() {
      topLinks.forEach(l => l.classList.remove('active'));
      this.classList.add('active');
      let cat = this.getAttribute('href').replace('/collections/', '');
      // Hide all megamenus
      megaMenus.forEach(menu => {
        menu.classList.add('hide');
        // document.querySelector('.top-menu--level-1').classList.remove('open');
      });
  
      // Show the matching megamenu
      const targetMenu = document.querySelector(`.top-menu--megamenu.sss[data-cat="${cat}"]`);
      if (targetMenu) {
        targetMenu.classList.remove('hide');
        // document.querySelector('.top-menu--level-1').classList.add('open');
      }
    });

    link.addEventListener('mouseleave', function(){
      
    });
  });
  
  megaMenus.forEach(menu => {
    menu.addEventListener('mouseleave', function(){
      this.classList.add('hide');
      // document.querySelector('.top-menu--level-1').classList.remove('open');
      topLinks.forEach(link => { link.classList.remove('active'); });
    });
  });

  megaMenuBoxs.forEach(menuBox => {
    menuBox.addEventListener('mouseleave', function(){
      topLinks.forEach(link => { link.classList.remove('active'); });
    });
  });

  topSimpleLinks.forEach(link => {
    link.addEventListener('mouseleave', function(){
      topLinks.forEach(link => { link.classList.remove('active'); });
    });
  });
  
  
  /* ========================================
  ======== Mega menu masonry script ======= */
  
  const megamenus = document.querySelectorAll('.top-menu--megmamenu-container.style--1 .megamenu-body');
  if (megamenus) {
    megamenus.forEach(megamenu => {
      var msnry = new Masonry( megamenu, {
        itemSelector: '.megamenu-item-block',
        // columnWidth: 200,
        percentPosition: true,
        // gutter: 20,
        // horizontalOrder: true,
        fitWidth: true
      });
    });    
  }

  window.addEventListener("resize", () => {
    const megamenus = document.querySelectorAll(".top-menu--megmamenu-container.style--1 .megamenu-body");
    
    if (megamenus) {
      megamenus.forEach(megamenu => {
        var msnry = new Masonry(megamenu, {
          itemSelector: ".megamenu-item-block",
          percentPosition: true,
          fitWidth: true
        });
      });
    }
  });


  /* ===============================================================
  ===== Sidebar Menu: Designers initial click to group script ======= */
  
  document.body.addEventListener("click", (e) => {
    const clickedInitial = e.target.closest(".header-sidebar .designers-initial:not(.disabled)");
    if (!clickedInitial) return;
  
    // Toggle active class
    document.querySelectorAll('.header-sidebar .designers-initial.active').forEach(el => {
      el.classList.remove('active');
    });
    clickedInitial.classList.add('active');
  
    // Get to-term string and its parent container
    let termStr = clickedInitial.getAttribute('to-term');
    if (!termStr) return;
  
    const container = clickedInitial.closest('.designers-container');
    if (!container) return;
  
    const scroller = document.querySelector('.header-sidebar__scroller');
    const header = document.querySelector('.shopify-section--header');
    const topMenu = document.querySelector('.shopify-section--top-menu');
    const offset = (header?.offsetHeight || 0) + (topMenu?.offsetHeight || 0) + 50;
  
    // Loop one character at a time
    for (let i = 0; i < termStr.length; i++) {
      const char = termStr[i];
      const targetGroup = container.querySelector(`.designer-list--group[term="${char}"]`);
      if (targetGroup) {
        // Scroll to the first matching group
        if (scroller) {
          scroller.scrollTo({
            top: targetGroup.offsetTop - offset,
            behavior: "smooth"
          });
        }
        break; // Stop after the first found match
      }
    }
  });


  
/* ====================================================
===== Designers initial click to group script ======= */

document.body.addEventListener("click", (e) => {
  const initial = e.target.closest(".shopify-section--designers .designers-initial:not(.disabled)");
  if (!initial) return;

  // Reset active state
  document.querySelectorAll(".shopify-section--designers .designers-initial").forEach(el => {
    el.classList.remove("active");
  });
  initial.classList.add("active");

  const term = initial.getAttribute("to-term");
  const header = document.querySelector(".shopify-section--header");
  const announcement = document.querySelector(".shopify-section--announcement-bar");
  const offset = (header?.offsetHeight || 0) + (announcement?.offsetHeight || 0) + 50;

  // Try to find the target group for this term
  let target_group = document.querySelector(`.shopify-section--designers .designer-list--group[term="${term}"]`);

  // If it doesn't exist, find the next available group
  if (!target_group) {
    const allGroups = Array.from(document.querySelectorAll(".shopify-section--designers .designer-list--group"));
    // Find the first group whose term is alphabetically greater than the clicked term
    target_group = allGroups.find(group => group.getAttribute("term") > term) || allGroups[allGroups.length - 1];
  }

  if (!target_group) return; // Safety guard

  window.scrollTo({
    top: target_group.offsetTop - offset,
    behavior: "smooth"
  });
});


  /* =============================================
  ======= Designers search filter script ======= */
  
  const input = document.getElementById("designer_search");
  const searchSection = document.querySelector("#designers_search_section");
  const items = document.querySelectorAll(".designer-list");
  const groups = document.querySelectorAll(".designer-list--group");
  const cancelButton = document.querySelector("#search_cancel");

  if (input) {
    input.addEventListener("keyup", () => {
      const filter = input.value.trim().toUpperCase();
      searchSection.classList.toggle("active", filter !== "");

      items.forEach(item => {
          const txtValue = item.textContent.trim() || item.innerText.trim();
          item.classList.toggle("hidden", !txtValue.toUpperCase().includes(filter));
      });

      groups.forEach(group => {
          const term = group.getAttribute("term");
          const hasVisibleItems = group.querySelector(".designer-list:not(.hidden)");

          group.classList.toggle("hidden", !hasVisibleItems);
          document.querySelector(`.designers-initials .designers-initial[to-term="${term}"]`)
              .classList.toggle("disabled", !hasVisibleItems);
      });
    });
  }

  if (cancelButton) {
    cancelButton.addEventListener("click", () => {
      input.value = "";
      input.dispatchEvent(new KeyboardEvent("keyup", { key: "Enter", keyCode: 13, bubbles: true }));

      document.querySelectorAll(".designers-initial").forEach(initial => {
          initial.classList.remove("active");
      });
    });
  }

    /* =============================================
  ======= Mobile menu featured collection image update ======= */

  const mobileBtns = document.querySelectorAll('.header-sidebar-head .header-sidebar__linklist-button');
  const featuredCols = document.querySelectorAll('.featured-collections-section .featured-collections-list');
  
  if (mobileBtns.length > 0) {
    mobileBtns.forEach(mobileBtn => {
      mobileBtn.addEventListener('click', () => {
        let menuType = mobileBtn.getAttribute('menu-type');
        featuredCols.forEach(featuredCol => featuredCol.classList.remove('active'));
        document.querySelector(`.featured-collections-section .featured-collections-list[menu-type="${menuType}"]`)?.classList.add('active');
      });
    });
  }

  /* =============================================
  ======= Mobile menu Contact trigger ======= */
  
  document.querySelector('#footer_contact_triger')?.addEventListener('click', function (e) {
    e.preventDefault();
    const parent = this.closest('.header-sidebar__footer');
    if (parent) {
      const talkBox = parent.querySelector('.header-sidebar__footer.talk-human');
      if (talkBox) {
        talkBox.classList.toggle('open');
      }
    }
  });

  /* =============================================
  ======= Mobile menu Top Level accordion action ======= */

  const _mobileTopLinks = document.querySelectorAll('.header-sidebar__scroller .top-level-menu');
  _mobileTopLinks.forEach(_toplink => {
    _toplink.addEventListener('click', function () {
      const isActive = this.classList.contains('active');
  
      _mobileTopLinks.forEach(link => link.classList.remove('active'));
      document.querySelector('.header-sidebar__scroller').classList.remove('active');
  
      if (!isActive) {
        this.classList.add('active');
        document.querySelector('.header-sidebar__scroller').classList.add('active');
      }
      
    });
  });

  const _mobileSubLinks = document.querySelectorAll('.header-sidebar__scroller>ul[data-level="1"] button');
  _mobileSubLinks.forEach(_mobileSubLink => {
    _mobileSubLink.addEventListener('click', function () {
      _mobileTopLinks.forEach(link => link.classList.add('hidden'));
    });
  });  

  const _backBtns = document.querySelectorAll('.back-parent[data-target*="main-panel-1-"]');
  _backBtns.forEach(_backBtn => {
    _backBtn.addEventListener('click', function () {
      _mobileTopLinks.forEach(link => link.classList.remove('hidden'));
    });
  });

  /* =============================================
  ======= Hero slideshow scrolldown next button action  ======= */

  document.querySelectorAll('.slideshow__next-section-button').forEach(sectionNextBtn => {
    sectionNextBtn.addEventListener('click', () => {
      const parentSection = sectionNextBtn.closest('.shopify-section');
  
      // Find next visible .shopify-section that doesn't have .smi-styles
      let targetSection = parentSection.nextElementSibling;
      while (targetSection && (targetSection.classList.contains('smi-styles') || !targetSection.classList.contains('shopify-section'))) {
        targetSection = targetSection.nextElementSibling;
      }
  
      if (targetSection) {
        const header1 = document.querySelector('.shopify-section--header');
        const header2 = document.querySelector('.shopify-section--top-menu');
        const headerHeight = (header1?.offsetHeight || 0) + (header2?.offsetHeight || 0);
  
        const scrollTargetY = targetSection.getBoundingClientRect().top + window.scrollY - headerHeight;
  
        window.scrollTo({
          top: scrollTargetY,
          behavior: 'smooth'
        });
      }
    });
  });

  /* =========== PDP media gallery update =============== */
  
  document.body.classList.contains("page-product")?document.body.classList.add("gallery-active"):null; 
/*
  function updateGalleryMode(){

    const scrollTop = window.scrollY;
    const infoTop = document.querySelector("safe-sticky.product-info").offsetTop;

    if(scrollTop < 20){

      document.body.classList.add("gallery-active");

    }else{

      document.body.classList.remove("gallery-active");

    }

  }

  window.addEventListener("scroll", updateGalleryMode);

  updateGalleryMode();
*/
  /* FIX (2026-07-31): the previous guard was commented out, so initProductGallery() re-ran on
     every MutationObserver hit (Shopify fires one on each variant change) and ADDED a fresh set of
     scroll listeners each time — measured +1 window-scroll and +1 gallery-scroll listener per DOM
     mutation. Each run closed over its OWN `collapsed` flag, so N handler sets held contradictory
     state and fought over gallery.style.height. That is why the page behaved worse the more the
     customer interacted with it.
     Re-init IS genuinely needed (Shopify replaces the section markup), so we do not simply skip it —
     we TEAR DOWN the previous run first. An AbortController removes every listener registered with
     its signal in one call; observers are tracked so they can be disconnected too. */
  let galleryTeardown = null;

  function initProductGallery() {

    /* tear down anything the previous init registered */
    galleryTeardown?.abort();
    galleryTeardown = new AbortController();
    const initSignal = galleryTeardown.signal;

    document.body.classList.contains("page-product")?document.body.classList.add("gallery-active"):null;   
    const carousel = document.querySelector(".shopify-section--main-product scroll-carousel");
    const carousel_items = carousel.querySelectorAll(".product-gallery__media");
    const carousel_dots = document.querySelectorAll(".shopify-section--main-product .scroll-marker");

    /* CLICK → Scroll to item
       ⚠️ FIXED 2026-08-14 (Rishi): the teardown signal was on the WRONG CALL. It was passed as a
       second argument to `scrollIntoView`, which takes a single options object and silently
       ignores anything after it — so `addEventListener` received no options at all and these
       listeners were never torn down.

       That leaked on every re-init, and this function re-runs on each mutation of the product
       section (variant change, app block injection). The abort at the top of the init only
       removes listeners that were actually registered with the signal, so each pass added another
       click handler to every dot. Worse than duplicate work: each stale closure captures that
       run's `carousel_items`, pinning a whole detached gallery in memory.

       Every other listener in this function was already registered correctly — 390, 463, 479,
       491, 495, 501 all pass `{ signal: initSignal }` to `addEventListener`. This one line was
       the odd one out, which is exactly why it survived: it LOOKS like the others. */
    carousel_dots.forEach((dot, index) => {
      dot.addEventListener("click", function () {
        /* ⚠️ Known and NOT fixed here: the dots are queried document-wide within the section
           (`.shopify-section--main-product .scroll-marker`) while the items are scoped to the
           carousel, so the two lists can disagree and `carousel_items[index]` be undefined.
           Left alone deliberately — that is a different bug and swallowing it with `?.` would
           hide a real mismatch rather than fix it. */
        carousel_items[index].scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, { signal: initSignal });
    });

    // SCROLL → Update active dot
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = [...carousel_items].indexOf(entry.target);

            carousel_dots.forEach((d) => d.setAttribute("aria-current", "false"));
            if (carousel_dots[index]) {
              carousel_dots[index].setAttribute("aria-current", "true");
            }
          }
        });
      },
      {
        root: window.innerWidth < 100 ? carousel : null, 
        threshold: 0.6
      }
    );

    carousel_items.forEach((item) => {
      observer.observe(item);
      /* ---- the img→lightbox forwarder that used to live here is GONE (2026-08-14, Delinda) ----
         It was `item.querySelector('img')?.addEventListener('click', function () {
         this.nextElementSibling.click(); })` — tap a gallery image, open the fullscreen lightbox.
         Delinda does not want click behaviour on the gallery, so it is removed rather than moved;
         see the REMOVED note further down (search: TAP AN IMAGE FOR FULLSCREEN) for the full
         history and for what it would take to bring it back.

         Two things worth keeping on record about the old line, because they explain why the
         behaviour looked erratic while it existed:
         · initProductGallery() has exactly ONE call site — inside galleryObserver's callback —
           so it NEVER ran on a clean page load. Tap-to-fullscreen only worked once something
           mutated the product section, which is why it could not be reproduced on a fresh load.
         · `this.nextElementSibling` was unguarded. <open-lightbox-button> is only rendered when
           product-gallery.liquid's condition holds, so on other media types the img is the last
           child and the handler threw. */
    });
    /* the IntersectionObserver is per-init too — drop it when this run is torn down */
    initSignal.addEventListener('abort', () => observer.disconnect(), { once: true }); 

    /* NOTE: an earlier abandoned implementation of this feature was removed here (2026-07-31). */ 

    /* mobile only */
    if (!window.matchMedia("(max-width: 749px)").matches) return;
    if (!document.body.classList.contains("page-product")) return;

    const body = document.body;
    const gallery = document.querySelector(".product > product-gallery");
    const galleryList = document.querySelector(".product-gallery__image-list");
    const info = document.querySelector("safe-sticky.product-info");
    const swapBtn = document.querySelector(".drag-handle-container");

    if (!gallery || !galleryList || !info) return;

    /* CHANGED (2026-07-31): was "calc(100svh - 255px)". The gallery is no longer its own
       scroll container — the images flow in the page (see "ONE SCROLLER" in r-custom.css) —
       so pinning a viewport-derived height here would CLIP them, because product-gallery
       still carries `overflow: hidden`. `auto` fits the content; the collapse path still
       works because height 0 + overflow hidden hides it completely. */
    const GALLERY_HEIGHT = "auto";

    let collapsed = false;
    let lastScrollY = window.scrollY;

    /* ---------- state ---------- */

    function expandGallery() {
      gallery.style.height = GALLERY_HEIGHT;
      body.classList.add("gallery-active");
      collapsed = false;
    }

    function collapseGallery() {
      gallery.style.height = "0px";
      body.classList.remove("gallery-active");
      collapsed = true;
    }

    expandGallery();

    /* ---------- gallery scroll ---------- */

    /* REMOVED (2026-07-31): this collapsed the gallery to height:0 the moment the inner list
       reached its last image. That is what made the details "snap" into place instead of the
       page simply carrying on scrolling, and it is what created the dead-end that led to the
       pull-to-refresh reload — the collapse was driven by the INNER scroll, which never moves
       the window, so there was no upward window scroll available to undo it.

       The gallery now chains its overscroll to the page instead (see `overscroll-behavior-y: auto`
       on .product-gallery__image-list in r-custom.css), so reaching the last image continues
       into the product details as one movement. Collapse is still available deliberately, via
       the drag handle below, and the pull-down restore still brings the gallery back. */

    /* ---------- page scroll (restore when scrolling up) ---------- */

    window.addEventListener("scroll", () => {

      const currentY = window.scrollY;
      const scrollingUp = currentY < lastScrollY;

      lastScrollY = currentY;

      if (!collapsed || !scrollingUp) return;

      if (info.getBoundingClientRect().top >= -5) {
        expandGallery();
      }

    }, { passive: true, signal: initSignal });

    /* ---------- restore by pulling down at the top ---------- */

    /* FIX (2026-07-31): the scroll-up restore above CANNOT fire after a collapse triggered by
       the inner gallery scroll. That scroll never moves the window, so window.scrollY is still
       0, there is no upward window scroll to detect, and on iOS the downward pull hit Safari's
       pull-to-refresh and reloaded the page instead. Restore from the gesture itself.
       Listeners stay passive (no preventDefault) — the reload is stopped declaratively by
       `overscroll-behavior-y: contain` in r-custom.css. This complements rather than replaces
       the scroll-up path: that one still handles the case where the window HAS been scrolled. */
    const PULL_THRESHOLD = 40;
    let pullStartY = null;

    document.addEventListener("touchstart", (e) => {
      pullStartY = (collapsed && window.scrollY <= 5) ? e.touches[0].clientY : null;
    }, { passive: true, signal: initSignal });

    document.addEventListener("touchmove", (e) => {
      if (pullStartY === null || !collapsed) return;
      if (e.touches[0].clientY - pullStartY < PULL_THRESHOLD) return;

      pullStartY = null;
      expandGallery();
      /* Deliberately does NOT touch galleryList.scrollTop. Collapsing only sets the WRAPPER's
         height, so the inner list keeps its own scroll position — the shopper comes back to the
         image they left. Forcing scrollTop to the end would be wrong when the collapse came from
         the drag handle rather than from scrolling to the last image. */
    }, { passive: true, signal: initSignal });

    document.addEventListener("touchend", () => {
      pullStartY = null;
    }, { passive: true, signal: initSignal });

    /* ---------- swap button ---------- */

    swapBtn?.addEventListener("click", () => {
      collapsed ? expandGallery() : collapseGallery();
    }, { signal: initSignal });


  } 

  /* ---------- hand the product identity from the bar to the page ----------
     Designer/title/price/colour exist in BOTH the sticky bar and a block under the gallery.
     Only one may be readable at a time: the bar carries it while the gallery fills the viewport,
     the page takes over once its own copy clears the bar.

     ⚠️ DELIBERATELY OUTSIDE initProductGallery(). It lived in there first and was intermittently
     dead — roughly 1 run in 3. That function tears its listeners down and re-attaches on every
     Shopify section re-render, and the sticky bar sits inside <product-rerender>; when a re-render
     landed while the bar was being replaced, the `identityBlock && stickyBar` guard skipped
     re-attaching while the previous listener had already been aborted. The handoff then simply
     stopped for the rest of the page life and both copies showed.

     Out here it is attached exactly once, and both elements are re-queried each frame rather than
     captured, so a section re-render swapping either node cannot leave a stale reference. */
  (() => {
    if (!document.body.classList.contains("page-product")) return;

    /* Both measured DOWNWARD from the bar's top edge, and both POSITIVE, i.e. the handoff happens
       while the block is still behind the bar.

       HIDE_LEAD used to be negative (hide only once the block had risen 8px ABOVE the bar). That
       left an 8px window where the block's top edge was peeking over the bar while the bar still
       showed its own copy — a sliver of "BALMAIN" visible under a bar that also said BALMAIN.
       A sweep caught it at exactly one scroll position out of 218. Leading the handoff by 4px
       instead means the bar has always let go before the block can appear.

       The gap between the two is the anti-flicker dead band: without it, parking on the boundary
       and micro-scrolling would toggle the class every frame and the row would flutter. */
    const HIDE_LEAD = 4;   // hide once the block's top is within 4px BELOW the bar's top edge
    const SHOW_LEAD = 24;  // show again only once it has fallen 24px below it
    const FALLBACK_BAR_H = 118;

    let barHeight = 0;    // cached only once measured while EXPANDED
    let hidden = document.body.classList.contains("r-identity-seen");
    let queued = false;

    const syncIdentity = () => {
      queued = false;
      /* The brand/price ROW, not the whole block (2026-10-07): on the phone `.r-identity` is `display: contents` now (r-custom.css
         "PHONE PDP BUY AREA"), which measures as an empty box at 0,0, and the REF row sits above the brand line; the bar's copy
         is of the brand/price row, so that row is what the handoff waits for. */
      const block = document.querySelector("[data-r-identity] .r-identity__row") || document.querySelector("[data-r-identity]");
      if (!block) return;

      /* Only trust a bar measurement taken while it is expanded — measuring mid-collapse would
         cache ~76px and move the trip line permanently. */
      if (!barHeight && !hidden) {
        const bar = document.querySelector("product-sticky-add-to-cart");
        const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
        if (h > 0) barHeight = h;
      }

      /* ⚠️ The cached height has to be INVALIDATED, not just measured once. The Afterpay row is
         appended to this bar and hydrates asynchronously — measured, ~3s after load — so the height
         it was cached at is the height BEFORE that row exists. Left stale, the trip line for the
         identity handoff sits a whole row too low and the page identity hides late. Re-measuring
         only when the height actually changes keeps the "expanded only" guard above intact. */
      if (barHeight && !hidden) {
        const bar = document.querySelector("product-sticky-add-to-cart");
        const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
        if (h > 0 && h !== barHeight) barHeight = h;
      }

      const line = window.innerHeight - (barHeight || FALLBACK_BAR_H);
      const top = block.getBoundingClientRect().top;

      if (!hidden && top <= line + HIDE_LEAD) {
        hidden = true;
        document.body.classList.add("r-identity-seen");
      } else if (hidden && top >= line + SHOW_LEAD) {
        hidden = false;
        document.body.classList.remove("r-identity-seen");
      }
    };

    /* ---------- hide the bar once the footer arrives ----------
       Rishi, 2026-08-11. Two constants, both FIXED and neither derived from the bar, so this
       cannot feed back on itself the way a bar-height-derived trigger would: the bar hides, its
       height changes, the trigger moves, and the two states chase each other. 80px is about the
       collapsed bar's height, so it lets go exactly as the footer would start being covered.
       The gap between the two values is the anti-flicker dead band. */
    const HIDE_FOOTER_AT = 80;
    const SHOW_FOOTER_AT = 56;
    let barHidden = false;

    const syncFooter = () => {
      /* ⚠️ The FIRST section of the footer GROUP, not the <footer> element. Shopify's footer group
         holds three sections here — trust icons, the newsletter block, then <footer> — and <footer>
         begins ~785px after the footer area actually starts. Keying on the tag meant the bar only
         retired once the customer reached the footer LINKS, which is what Rishi reported.
         querySelector returns the first in document order, which is the top of the group.
         The <footer> fallback covers a theme where the group class is ever dropped. */
      const footer = document.querySelector(".shopify-section-group-footer-group")
                  || document.querySelector("footer");
      if (!footer) return;
      const top = footer.getBoundingClientRect().top;

      if (!barHidden && top <= window.innerHeight - HIDE_FOOTER_AT) {
        barHidden = true;
        document.body.classList.add("r-bar-in-footer");
      } else if (barHidden && top >= window.innerHeight - SHOW_FOOTER_AT) {
        barHidden = false;
        document.body.classList.remove("r-bar-in-footer");
      }
    };

    /* ---------- gallery <-> details jump button (2026-08-13, Rishi) ----------
       A round control straddling the top edge of the bar. Points DOWN while the gallery is what
       you are looking at and jumps to the product details; points UP once you are in the details
       and jumps back to the top of the gallery.

       ⚠️ Direction is DERIVED FROM SCROLL POSITION, never toggled by the click. Rishi described it
       as "rotate after the click", and a click-toggled flag gives exactly that — until someone
       scrolls by hand, at which point the arrow points the way they just came. Deriving it means
       the arrow is right no matter how the shopper got there, and the post-click rotation still
       happens because the click moves the scroll position past the threshold. */
    /* Breathing room so the first line is not welded to the header. Went to 0 on 2026-08-14 while
       the landing point was a full-bleed bar, where a gap only exposed a sliver of image; back to
       8px now that the anchor is a block of text again. */
    const HEADER_CLEARANCE = 8;
    const DIRECTION_DEADBAND = 40;

    /* ⚠️ ANCHOR ON THE CONTENT BLOCK. This has now been wrong in both directions, so it is worth
       stating the rule rather than the history: the target is the top of `.r-pdp-extra`, because
       that is where the product's written detail begins, whatever happens to be rendered inside it.

       It briefly anchored on `.r-trust-strip` on 2026-08-13, when a strip genuinely was the first
       thing under the gallery. On 2026-08-14 Delinda had the strips moved down a slot — and this
       line kept resolving, silently, to the FIRST strip in the document, which is now
       "Brand New / Designer Direct" sitting BELOW the brand, price, title, colour and ref. Measured
       at 402px: it overshot by 143px and scrolled the shopper straight past the identity block.
       Nothing errored; the jump just quietly started landing in the wrong place.

       Keying on the container rather than on whatever sits at the top of it is what stops this
       recurring the next time the contents are reordered. */
    /* ---- the landing point is DERIVED, not a tuned number (2026-08-14, Rishi) ----
       It was briefly a fixed "leave 140px of gallery showing", taken off his own scroll position
       in Chrome. Wrong shape of answer twice over: it encoded a symptom instead of the reason, and
       a pixel constant measured in one engine does not survive the trip to another — the same
       number left visibly more image on iOS, which is how he spotted it was "close but not the
       same".

       The reason he chose an odd-looking position is two real constraints, and both can be
       measured on the device at the moment of the tap:

         · THE CHAT BUBBLE MUST NOT COVER THE COMPARE-AT PRICE. Both sit hard right, so they
           collide. Scrolling further lifts the price toward the bubble, so this is a CEILING.
         · THE FIRST TWO TRUST SIGNALS MUST BE ON SCREEN. Scrolling further lifts the second one
           into view, so this is a FLOOR.

       Measured at 402x874 those leave a window about 49px wide, which is why eyeballing it kept
       missing. Deriving it also keeps it right on a product with a taller price row, a longer
       title, or no second strip at all.

       ⚠️ The bubble is `position: fixed`, so its rect is ALREADY in viewport coordinates and must
       not have scrollY added to it. Everything else here is converted to document coordinates. */
    const BUBBLE_GAP = 12;   /* daylight between the bubble's lower edge and the price row */
    const STRIP_GAP = 0;     /* the second strip only has to be ON screen, not held off the bar */

    /* ⚠️ RESERVE THE WHOLE IFRAME, and do not try to be cleverer than that.
       The visible launcher is smaller than the 300x150 iframe carrying it, and an earlier version
       here subtracted a 30px inset to win back some ceiling. That inset was estimated off a
       screenshot, not measured — it cannot be measured, because the circle lives in a cross-origin
       document and there is no element in ours that matches it (checked: the iframe's ancestors
       are all zero-height wrappers, and it has no siblings). The estimate was too generous and
       left the price clipped along its top edge.
       The iframe bound is the only honest one available, and over-reserving costs nothing here:
       measured on device it still leaves both constraints satisfiable. */

    const contentTargetY = () => {
      const anchor = document.querySelector(".r-pdp-extra");
      if (!anchor) return null;
      const header = document.querySelector(".shopify-section--header");
      /* Measured live rather than hardcoded: the header is 59px on some pages and 66px on others
         depending on whether the announcement bar is showing. */
      const headerH = header ? header.getBoundingClientRect().height : 0;
      const docTop = (el) => el.getBoundingClientRect().top + window.scrollY;
      const docBottom = (el) => el.getBoundingClientRect().bottom + window.scrollY;

      /* The ideal, with nothing in the way: content sitting just under the header. */
      const flush = docTop(anchor) - headerH - HEADER_CLEARANCE;
      let target = flush;

      /* FLOOR — lift the second trust signal above the sticky bar. */
      const strips = document.querySelectorAll(".r-trust-strip");
      const bar = document.querySelector(".product-sticky-add-to-cart");
      const jump = document.querySelector(".r-jump");
      if (strips[1]) {
        const occluded = (bar ? bar.getBoundingClientRect().height : 0) +
                         (jump ? jump.getBoundingClientRect().height : 0);
        target = Math.max(target, docBottom(strips[1]) - (window.innerHeight - occluded) + STRIP_GAP);
      }

      /* CEILING — keep the compare-at price clear of the chat bubble's visible circle.
         ⚠️ ORDER MATTERS, and it is the opposite of the obvious one. This is applied LAST so that
         where the two cannot both be met, the PRICE wins. That is the constraint Rishi is actually
         protecting — the struck-through compare-at is the discount anchor, and a bubble sitting on
         it costs the thing the page is selling. The strip loses only a few pixels of clearance in
         that case; measured on device the two are ~18px apart, so it stays on screen either way.
         Reversed once already: with the floor last, the bubble covered the price on every landing. */
      const price = document.querySelector(".r-identity__price");
      const bubble = document.querySelector("#chat-button");
      if (price && bubble) {
        const bubbleRect = bubble.getBoundingClientRect();
        if (bubbleRect.height > 0) {
          target = Math.min(target, docTop(price) - bubbleRect.bottom - BUBBLE_GAP);
        }
      }

      /* Never scroll past the content's own start — a short gallery could otherwise ask for more
         page than exists. */
      return Math.max(0, Math.min(target, flush));
    };

    const inDetails = () => {
      const target = contentTargetY();
      return target !== null && window.scrollY >= target - DIRECTION_DEADBAND;
    };

    const syncJump = () => {
      const btn = document.querySelector(".r-jump");
      if (!btn) return;
      const up = inDetails();
      btn.classList.toggle("r-jump--up", up);
      // The label has to describe what the NEXT press does, not where the shopper is.
      btn.setAttribute("aria-label", up ? "Back to product images" : "Skip to product details");
    };

    /* ---- the glide (2026-08-13, Rishi: "the scrolling is too fast") ----
       Native `behavior: "smooth"` has a fixed, browser-chosen duration, and over this gallery —
       measured 3,774px, about 4.6 screens — that reads as a snap rather than a scroll. There is no
       way to slow the native one down, so this tweens it by hand.

       Duration scales with distance and is clamped, so a short hop is not sluggish and the long
       run up the gallery is not a blur. At ~3,800px it lands near 1.1s. */
    let scrollAnim = null;
    const animateScrollTo = (targetY) => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        window.scrollTo(0, targetY);
        return;
      }
      if (scrollAnim) cancelAnimationFrame(scrollAnim);

      const startY = window.scrollY;
      const delta = targetY - startY;
      if (!delta) return;
      /* Slower again (Rishi, 2026-08-13) — 0.28 -> 0.38 per pixel, ceiling 1400 -> 1800ms. At the
         full gallery height that is ~1.45s rather than ~1.07s. */
      const duration = Math.min(1800, Math.max(700, Math.abs(delta) * 0.38));
      const start = performance.now();
      /* ⚠️ SINE, not cubic. Cubic ease-in-out is nearly flat at both ends and then rips through the
         middle — over 3,774px that mid-run velocity is what reads as jerky, because the page is
         being repainted at speed on the main thread. Sine has the same soft ends with a much gentler
         peak, so the whole travel stays at a speed the compositor can keep up with. */
      const easeInOutSine = (t) => -(Math.cos(Math.PI * t) - 1) / 2;

      /* ⚠️ Hand back control the moment the shopper touches the screen. Without this the tween keeps
         driving the page while they are trying to scroll it themselves, which feels broken. */
      let aborted = false;
      const abort = () => { aborted = true; };
      const stopListening = () => {
        window.removeEventListener("wheel", abort);
        window.removeEventListener("touchstart", abort);
      };
      window.addEventListener("wheel", abort, { passive: true });
      window.addEventListener("touchstart", abort, { passive: true });

      const step = (now) => {
        if (aborted) { scrollAnim = null; stopListening(); return; }
        const p = Math.min(1, (now - start) / duration);
        window.scrollTo(0, Math.round(startY + delta * easeInOutSine(p)));
        if (p < 1) {
          scrollAnim = requestAnimationFrame(step);
        } else {
          scrollAnim = null;
          stopListening();
        }
      };
      scrollAnim = requestAnimationFrame(step);
    };

    const onJumpClick = () => {
      if (inDetails()) {
        animateScrollTo(0);
      } else {
        const target = contentTargetY();
        if (target !== null) animateScrollTo(target);
      }
    };

    const mountJump = () => {
      const bar = document.querySelector("product-sticky-add-to-cart");
      if (!bar || bar.querySelector(":scope > .r-jump")) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "r-jump";
      /* Inline SVG rather than an uploaded asset: it is two strokes, it inherits currentColor, and
         it stays crisp at any size. Double chevron per Rishi's reference image. */
      /* ⚠️ The two chevrons are a MATCHED PAIR — the small one is the large one at exactly 50%,
         same slope, same vertex x. Widening the viewBox without rescaling both is what made only
         the lower one look wider (measured once: 46% of the lower rather than 50%). Keep the ratio
         if these are ever retuned.

         Width and slope have been tuned separately more than once (44x18 slope 0.5 -> 34x12 slope
         0.4 -> 44x12 slope 0.28). They are independent: widening alone makes the same angle span
         further, which reads as BIGGER rather than flatter. Only the slope flattens it.
             large  half-width 20, depth 5.6 -> slope 0.28
             small  half-width 10, depth 2.8 -> slope 0.28
         ⚠️ The viewBox height stays 12 and so does the rendered block-size, which is what keeps the
         strip on 24px — the glyph box is what the 6px padding is measured from. A taller viewBox
         here would push the strip past the WCAG target-size floor. */
      btn.innerHTML =
        '<svg class="r-jump__icon" viewBox="0 0 44 12" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="M12 2 22 4.8 32 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M2 4.2 22 9.8 42 4.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>";
      btn.addEventListener("click", onJumpClick);
      /* Appended to the BAR, outside its <product-rerender>, for the same reason as the Afterpay
         slot: that child is replaced wholesale on every variant change. */
      bar.appendChild(btn);
      syncJump();

      /* One-off nudge on load so the strip reads as "there is more below" rather than as a bar
         (Rishi, 2026-08-13). Only when it is actually pointing down — on a restored scroll position
         the shopper is already in the details, and a downward hint there would be pointing the
         wrong way. Plays once, never loops; the CSS drops it entirely under reduced motion. */
      if (!inDetails()) btn.classList.add("r-jump--hint");
    };

    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { syncIdentity(); syncFooter(); syncJump(); });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    /* Shopify replaces the section on variant change; re-sync after it settles so the state is
       correct even if the swap happened without a scroll. */
    document.addEventListener("shopify:section:load", onScroll);
    /* ⚠️ THE JUMP STRIP IS NO LONGER MOUNTED (2026-10-07, Rishi: "I would like to also remove the chevron bar from the sticky atc
       bar."). mountJump() is kept for the record but never called; syncJump() and contentTargetY() return early without the strip.
       With it went the footer's back-to-top role and the page's bottom padding (r-custom.css "PHONE PDP BUY AREA"). */
    syncIdentity();
    syncFooter();
    requestAnimationFrame(() => { syncIdentity(); syncFooter(); });
  })();

  /* ---------- reference-number copy: screen-reader announcement ---------- */

  /* The theme's <copy-button> does the copying and the visual state; it does not announce.
     This fills the live region so the action is not silent for assistive tech. Delegated,
     so it survives Shopify's section re-render on variant change. */
  document.addEventListener("click", (event) => {
    if (!event.target.closest("copy-button.r-meta__copy")) return;

    const status = document.querySelector("[data-copy-status]");
    if (!status) return;

    status.textContent = "Reference number copied";
    setTimeout(() => { status.textContent = ""; }, 2000);
  });

  /* ---------- model info modal ---------- */

  /* Native <dialog>: showModal() puts it in the browser top layer, above every z-index on the
     page (including the Gorgias iframe at the 32-bit max), and gives Esc-to-close and focus
     trapping for free. Delegated so it survives Shopify's section re-render on variant change. */
  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-model-open]");
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute("data-model-open"));
      if (dialog && typeof dialog.showModal === "function") dialog.showModal();
      return;
    }

    if (event.target.closest("[data-model-close]")) {
      event.target.closest("dialog")?.close();
      return;
    }

    /* Click on the backdrop closes. The dialog element itself spans the whole viewport as far
       as the event target is concerned, so compare against its content box rather than
       checking `event.target === dialog` alone. */
    const openDialog = event.target.closest("dialog.r-modal");
    if (openDialog) {
      const box = openDialog.getBoundingClientRect();
      const outside =
        event.clientX < box.left || event.clientX > box.right ||
        event.clientY < box.top  || event.clientY > box.bottom;
      if (outside) openDialog.close();
    }
  });

  /* ---- strip trailing empty blocks from the product description (2026-08-14, Rishi) ----
     Rishi saw the gap under the description "look really off" on a Versace PDP and asked whether
     the spacing was not the same on every page. It is — the DESCRIPTIONS differ. That product's
     descriptionHtml ends:

         <p><span>Long-sleeved pink silk…at the waist.</span></p><p> </p><p> </p><p><br></p>

     Three blank paragraphs, each rendering a full line box plus its margin: ~150px of dead space
     that no CSS rule put there.

     ⚠️ MEASURED BEFORE FIXING, because the shape of the data decided the tool. Of 6,774 active
     products, 1,068 (15.8%) end in at least one empty block — 1,446 blocks in total, up to 6 on a
     single product. Crucially they take 118 DISTINCT literal forms, and the ten commonest cover
     only ~85%: `<p>&nbsp;</p>` and `<div><br></div>` lead, but the tail is scraped-vendor markup
     like `<div><div class="ltr-13pqkh2 exjav150">…</div></div>` — empty of text, full of wrappers.
     A Liquid `replace` chain would have been whack-a-mole against that tail, and CSS cannot test
     text content at all (`:empty` matches none of these — a single space is content). Removing it
     from the DOM, where `textContent` is readable, is the only approach that covers all 118.

     ⚠️ Trailing ONLY. 63 empty blocks sit mid-description across the catalogue; those may be
     deliberate paragraph spacing and are left alone.

     Media-bearing blocks are kept even with no text — an image-only paragraph is not empty. */
  function stripDescriptionTail() {
    const MEDIA = "img, video, iframe, svg, picture, source, object, embed";
    document.querySelectorAll(".r-pdp-description").forEach((desc) => {
      let last;
      while ((last = desc.lastElementChild)) {
        if (last.matches(MEDIA) || last.querySelector(MEDIA)) break;
        /* NBSP is the usual culprit and does not trim as whitespace on its own. */
        if (last.textContent.replace(/ /g, " ").trim()) break;
        last.remove();
      }
      /* A bare trailing <br> outside any block leaves half a line behind. */
      while (desc.lastChild && desc.lastChild.nodeName === "BR") desc.lastChild.remove();
    });
  }

  stripDescriptionTail();

  /* ---- TAP AN IMAGE FOR FULLSCREEN: REMOVED (2026-08-14, Delinda) ------------------------
     ⚠️ DO NOT RE-ADD without asking. This has now been through a full round trip in one day and
     the end state is deliberate, not an oversight:

       · it existed by accident, via an unguarded forwarder inside initProductGallery();
       · Rishi saw it, liked it, and asked to keep it — "pinch or tap";
       · it was rebuilt properly here as a delegated, guarded, zoom-aware listener;
       · Delinda then said she does not want click behaviour on the gallery at all.

     Her call is the current one, so the listener is gone. **Pinch-to-zoom-in-place is the only
     gallery zoom interaction on mobile**, which is what the module at the bottom of this file
     was built for in the first place.

     Consequence worth knowing: clicking a gallery IMAGE no longer opens the lightbox at ANY
     width, desktop included. That is not a regression against anything deliberate — on desktop
     it only ever worked through the same accidental forwarder — and desktop still has its own
     visible <open-lightbox-button>, which is untouched and is the intended affordance there.
     If desktop image-click is ever wanted back, it is this listener plus a `min-width: 1000px`
     matchMedia gate, and it needs Delinda's sign-off because it is her decision that removed it.

     The theme's own pinch→lightbox path (ProductGallery.onGestureChanged fires `lightbox:open`
     above scale 1.5) stays suppressed by the capture-phase cancel in the pinch module — removing
     this listener does NOT bring that back. */

  /* ---------- PDP information tabs ---------- */

  /* Delegated on document so it survives Shopify's section re-render on variant change,
     and so it does not care how many <r-tabs> are on the page. `is-ready` is added on init:
     until then CSS shows every panel, so the content is reachable if JS never runs. */
  document.querySelectorAll("r-tabs").forEach((tabs) => tabs.classList.add("is-ready"));

  /* ---- sliding active-tab marker (2026-08-14, Rishi) ----
     One 2px bar per tab list that travels to the selected tab and resizes to its label, rather
     than three underlines toggling on and off. Created here rather than in Liquid so the markup
     stays free of an element that means nothing without JS — and so the CSS fallback (the per-tab
     border) is what paints until the bar is genuinely ready to take over.

     ⚠️ Idempotent by design. The tabs live inside `<product-rerender>`, so a variant change
     destroys this bar along with them; the same debounced observer that re-places the BNPL message
     calls this again, and it rebuilds only when the element is actually missing. */
  function syncTabMarker() {
    document.querySelectorAll("r-tabs .r-tabs__list").forEach((list) => {
      var marker = list.querySelector(":scope > .r-tabs__marker");
      if (!marker) {
        marker = document.createElement("span");
        marker.className = "r-tabs__marker";
        /* Decorative: the selected state is already carried by aria-selected on the tab, so
           announcing this too would just repeat it. */
        marker.setAttribute("aria-hidden", "true");
        list.appendChild(marker);
        list.classList.add("r-tabs__list--marked");
      }

      var active = list.querySelector('.r-tabs__tab[aria-selected="true"]');
      if (!active) { marker.style.width = "0px"; return; }

      /* Width comes from the tab's own box, which IS its text: `.r-tabs__tab` carries no inline
         padding and no side borders, so offsetWidth is the label and nothing else. If horizontal
         padding is ever added to the tabs, this stops matching the text and would need measuring
         off a Range around the text node instead. */
      marker.style.width = active.offsetWidth + "px";
      marker.style.transform = "translateX(" + active.offsetLeft + "px)";
    });
  }

  document.addEventListener("click", (event) => {
    const tab = event.target.closest(".r-tabs__tab");
    if (!tab) return;

    const tabs = tab.closest("r-tabs");
    if (!tabs) return;

    /* ---- accordion instances can close (2026-08-17, Rishi) ----
       The desktop copy is presented as an accordion, and a disclosure that cannot be re-closed is
       a broken disclosure: the shopper opens SHIP/RETURN to check the returns window and has no
       way to get the column back to its compact state. Tabs keep their old behaviour — one is
       always open, because a tab group with nothing selected is the broken case there.
       Still ONE open at a time either way: this column is only fixed while it fits the viewport,
       and stacking three open panels is what breaks that. */
    const isAccordion = tabs.classList.contains("r-tabs--in-column");
    const collapse = isAccordion && tab.getAttribute("aria-expanded") === "true";

    tabs.querySelectorAll(".r-tabs__tab").forEach((t) => {
      const selected = !collapse && t === tab;
      t.setAttribute("aria-selected", selected ? "true" : "false");
      if (isAccordion) t.setAttribute("aria-expanded", selected ? "true" : "false");
      const panel = document.getElementById(t.getAttribute("aria-controls"));
      if (!panel) return;
      /* The desktop accordion SLIDES (2026-10-01, Rishi: "the content area grows but it feels jerky. Can you smoothen this
         operation"). It used to flip `hidden`, so the column's height — and, since the same day, its centred position — jumped
         in one frame. Sliding the height lets the sticky column's ResizeObserver re-centre it on every frame of the move. The
         phone's tabs keep the instant switch. */
      if (isAccordion) rSlidePanel(panel, selected); else panel.hidden = !selected;
    });
    syncTabMarker();
  });

  /* Open or close one accordion panel by animating its height and vertical padding (0.3s, the same curve as Read More).
     ⚠️ Heights are border-box (theme.css sets `box-sizing: border-box` on everything), so the end height already includes
     the panel's padding; the padding animates to and from 0 alongside it, or a "closed" panel would still show 2.75rem.
     ⚠️ A click mid-slide reverses from wherever the panel is: the start height is read from the live box, and the pending
     cleanup is cancelled first. The 450ms fallback finishes the job if `transitionend` never fires (no change in height).
     Reduced motion: the old instant switch. */
  function rSlidePanel(panel, open) {
    const sliding = panel.dataset.rSlide;
    const isOpen = sliding ? sliding === "opening" : !panel.hidden;
    if (open === isOpen) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      panel.hidden = !open;
      return;
    }
    if (panel._rSlideDone) panel._rSlideDone(true);

    const startH = panel.hidden ? 0 : panel.getBoundingClientRect().height;
    const startPadT = panel.hidden ? "0px" : getComputedStyle(panel).paddingTop;
    const startPadB = panel.hidden ? "0px" : getComputedStyle(panel).paddingBottom;

    /* Measure the panel fully open with no inline overrides. */
    panel.hidden = false;
    panel.style.transition = "none";
    panel.style.height = "";
    panel.style.paddingTop = "";
    panel.style.paddingBottom = "";
    const fullH = panel.getBoundingClientRect().height;
    const padT = getComputedStyle(panel).paddingTop;
    const padB = getComputedStyle(panel).paddingBottom;

    panel.style.overflow = "hidden";
    panel.style.height = startH + "px";
    panel.style.paddingTop = startPadT;
    panel.style.paddingBottom = startPadB;
    void panel.offsetHeight;
    panel.style.transition = "height 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    panel.style.height = (open ? fullH : 0) + "px";
    panel.style.paddingTop = open ? padT : "0px";
    panel.style.paddingBottom = open ? padB : "0px";
    panel.dataset.rSlide = open ? "opening" : "closing";

    let timer = 0;
    const done = (interrupted) => {
      panel.removeEventListener("transitionend", onEnd);
      clearTimeout(timer);
      panel._rSlideDone = null;
      delete panel.dataset.rSlide;
      if (interrupted) return;       /* the next slide takes over from the live box */
      if (!open) panel.hidden = true;
      panel.style.transition = "";
      panel.style.height = "";
      panel.style.paddingTop = "";
      panel.style.paddingBottom = "";
      panel.style.overflow = "";
    };
    const onEnd = (e) => {
      if (e.target === panel && e.propertyName === "height") done(false);
    };
    panel._rSlideDone = done;
    panel.addEventListener("transitionend", onEnd);
    timer = setTimeout(() => done(false), 450);
  }

  /* ---- start the desktop accordion fully collapsed (2026-08-17, Rishi) ----
     The Liquid always marks one tab selected, which is right for a tab group and wrong for an
     accordion — the whole point of the change is that the column is short until the shopper asks
     for more. Also swaps the ARIA from the tab pattern to a disclosure pattern, because the
     visual affordance now says "three independent sections", and role="tab" would tell a screen
     reader something the eye is not being told.

     ⚠️ Runs for `.r-tabs--in-column` at any width — that instance is `display: none` below 1000px,
     so collapsing it costs nothing there, and gating on a breakpoint would leave it expanded for
     anyone who loads narrow and then widens the window. */
  function initColumnAccordion() {
    document.querySelectorAll("r-tabs.r-tabs--in-column").forEach((acc) => {
      if (acc.dataset.rAccReady === "1") return;   /* idempotent: survives the re-render frame */
      acc.dataset.rAccReady = "1";

      const list = acc.querySelector(".r-tabs__list");
      if (list) list.setAttribute("role", "presentation");

      acc.querySelectorAll(".r-tabs__tab").forEach((t) => {
        t.removeAttribute("role");
        t.setAttribute("aria-selected", "false");
        t.setAttribute("aria-expanded", "false");
        const panel = document.getElementById(t.getAttribute("aria-controls"));
        if (panel) {
          panel.hidden = true;
          panel.setAttribute("role", "region");
        }
      });
    });
  }

  initColumnAccordion();

  syncTabMarker();

  /* ⚠️ Re-measure once webfonts land. Montserrat arrives after first paint, and the label widths
     it produces are not the fallback's — measuring only at DOMContentLoaded leaves the bar sized
     to a font the shopper never sees. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncTabMarker);

  /* Label widths change with the breakpoint, and the list scrolls horizontally under 320px. */
  var tabResizeQueued = false;
  window.addEventListener("resize", function () {
    if (tabResizeQueued) return;
    tabResizeQueued = true;
    requestAnimationFrame(function () { tabResizeQueued = false; syncTabMarker(); });
  });

  /* ---------- size-guide triggers: beside the size dropdown, in the model row, in the size popover ---------- */

  /* Opens the size guide (x-drawer#r-size-guide, snippets/r-size-guide.liquid) from any `.js-size-guide-open` button.
     2026-09-29, Kiwi removed from the draft (Rishi: "remove kiwi from the draft pdp and put the new link in its place"):
     this used to click Kiwi's hidden `.size-guide` trigger. One handler for all three buttons, and none of them carries
     aria-controls: the dropdown's CSS keys on `button.select[aria-controls]` and the button beside it is also `.select`.
     Inside the size popover, the popover is closed FIRST and the drawer opened second: hide() releases the popover's
     focus trap, then show() takes focus into the guide (and returns it to the button on close).
     Delegated on document, deliberately: the variant picker renders TWICE on a mobile PDP (page + sticky bar), so a
     direct `querySelector(...).addEventListener` would only ever bind the first one. The drawer is looked up at click
     time: it is moved to <body> while open and back afterwards. */
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".js-size-guide-open");
    if (!trigger) return;
    const guide = document.getElementById("r-size-guide");
    if (!guide || typeof guide.show !== "function") return;
    const popover = trigger.closest("x-popover");
    if (popover && popover.open && typeof popover.hide === "function") popover.hide();
    guide.show({ activator: trigger });
  });

  const productSection = document.querySelector(".shopify-section--main-product");

  /* FIX (2026-07-31): this fired once per mutation and Shopify emits several per variant change,
     so init ran repeatedly within a frame. Coalesce to one re-init per animation frame. */
  let galleryReinitQueued = false;
  const galleryObserver = new MutationObserver(() => {

    if (galleryReinitQueued) return;
    if (!document.querySelector(".product > product-gallery")) return;

    galleryReinitQueued = true;
    requestAnimationFrame(() => {
      galleryReinitQueued = false;
      if (document.querySelector(".product > product-gallery")) initProductGallery();
    });

  });

  /* ⚠️ GUARD — same bug as the bnplObserver one further down, and THIS is the one that actually
     bites: it runs first, so while it was unguarded the guard down there was never even reached.
     `.shopify-section--main-product` exists only on a product page, so on collections, cart, search
     and the FAQ this threw "parameter 1 is not of type 'Node'" and aborted the rest of the handler,
     killing every listener registered between here and its close. */
  if (productSection) {
    galleryObserver.observe(productSection, {
      childList: true,
      subtree: true
    });
  }

  /* ---- Afterpay instalment message -> the identity block (2026-08-12, Rishi) ----
     The Afterpay on-site-messaging APP BLOCK renders inside `.product-info`, which this PDP hides
     and takes out of flow. An app block can only be rendered where the section places it in its
     block order, so it cannot be emitted inside `r-product-identity.liquid`. This moves the app's
     own element into the slot above the price instead.

     Why move the real node rather than declare our own <square-placement>: the amount is
     Afterpay's to compute and their element re-renders with the section on a variant change. The
     identity block does NOT re-render on a variant change, so a hand-rolled copy would freeze on
     the first variant's price — the same failure the store-availability label had this morning.

     Shopify replaces `.product-info` wholesale on every variant change, which destroys the moved
     node and rebuilds it in its original hidden home, so this has to run again after each
     re-render. It is idempotent: if the block is already in the slot it does nothing. */
  /* ---- WHICH instalment message, by price (2026-08-14, Rishi) ----
     Two providers are installed and they cover different bands, so the page shows whichever can
     actually serve the product in front of the shopper:

       under $30      Afterpay   (PayPal's floor is $30 — it renders nothing below it)
       $30 – $1,499   PayPal     2,816 of 3,014 live in-stock products, 93.4%
       $1,500 – $1,999 Afterpay  90 products, the band PayPal's ceiling excludes
       $2,000+        neither    103 products, past both ceilings

     Measured across the live catalogue: 96.6% of products get a message, which is exactly what
     Afterpay reached on its own — so preferring PayPal costs no coverage.

     ⚠️ THE DECISION IS MADE FROM PRICE, NOT FROM ASKING THE WIDGETS. PayPal renders inside a
     cross-origin zoid iframe, so there is no way to read whether it produced a message; Afterpay's
     state is readable only through shadow text. A price rule is the one signal available for both.

     ⚠️ The thresholds are in the DISPLAYED currency, and that is correct rather than sloppy:
     PayPal's limits are $30–$1,500 in BOTH CAD and USD, and Afterpay's are $1–$2,000 in both, so
     the same numbers hold in either market. If a third currency is ever added this needs revisiting.
     ⚠️ The sentence that used to end this note — "`Shopify.currency.rate` converts the shop-currency
     price the analytics meta reports" — was WRONG and is retracted. The analytics meta reports the
     PRESENTMENT price, already converted, so `currentVariantPrice` must NOT apply the rate. See the
     measurement in that function. Comparing a presentment price against these raw limits is exactly
     what the paragraph above says to do. */
  var BNPL_LIMITS = { ppMin: 30, ppMax: 1500, apMin: 1, apMax: 2000 };

  function currentVariantPrice() {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!meta || !meta.variants || !meta.variants.length) return null;
    /* The theme rewrites ?variant= on every size change, so the URL is the live answer. Falls back
       to the id the page rendered with, then to the first variant — a product whose variants differ
       in price would otherwise decide on the wrong one. */
    var id = Number(new URLSearchParams(location.search).get("variant")) || meta.selectedVariantId;
    var v = null;
    for (var i = 0; i < meta.variants.length; i++) {
      if (meta.variants[i].id === id) { v = meta.variants[i]; break; }
    }
    if (!v) v = meta.variants[0];

    /* 🚨 NO CURRENCY CONVERSION HERE, AND THE LINE THAT USED TO DO IT WAS A DOUBLE CONVERSION.
       This read `(v.price / 100) * Shopify.currency.rate` with the comment "meta prices are cents of
       the SHOP currency". That premise is false: `ShopifyAnalytics.meta` reports the PRESENTMENT
       price, already converted. Measured on one product across both currencies, 2026-08-21:
           ?currency=CAD  → rate "1.0"       meta price 240000   ($2,400.00 CAD)
           ?currency=USD  → rate "0.726364"  meta price 174400   ($1,744.00 USD)
       The meta value tracks the presentment currency, so multiplying by the rate converted a second
       time — on that product the gate saw 1744 * 0.726364 = $1,266.78 against a real $1,744.

       ⚠️ IT WAS INVISIBLE IN CAD because the rate is exactly 1.0 there, which is why every check at
       1440 and 375 passed. Any verification of this function that does not switch currency proves
       nothing.

       ⚠️ IT MATTERED MORE FROM 2026-08-21, which is why it is fixed here rather than left as
       pre-existing: until then a wrong price only picked which widget to show. Now it also drives
       `syncPaymentsList`, i.e. shopper-visible text stating which payment methods the store accepts —
       a USD shopper on that $1,744 dress was told "PayPal in 4" applies to an order PayPal will not
       fund. Served ad URLs force `?currency=usd`, so this is the majority paid-traffic path.

       ⚠️ Comparing the presentment price against the raw limits is CORRECT, not a second bug:
       PayPal's $30–$1,500 and Afterpay's $1–$2,000 hold in CAD and USD alike — see BNPL_LIMITS. */
    return v.price / 100;
  }

  function pickBnplProvider(price) {
    var L = BNPL_LIMITS;
    if (price === null) return "paypal";          // unknown → the one covering 93% of the catalogue
    if (price >= L.ppMin && price < L.ppMax) return "paypal";
    if (price >= L.apMin && price < L.apMax) return "afterpay";
    return null;                                   // over both ceilings: show nothing
  }

  /* ---- PER-PROVIDER ELIGIBILITY (2026-08-21) ----
     `pickBnplProvider` answers "which ONE do we show", which is the right question for the mobile
     ink bar and the wrong one for desktop, where both can appear. Asking it twice cannot work: it
     returns PayPal whenever PayPal qualifies, so Afterpay could never be read off it.

     ⚠️ Unknown price → BOTH true, deliberately, and this differs from `pickBnplProvider`'s
     "unknown → paypal". Here the answer feeds a HIDE decision, and hiding a payment method we do
     in fact accept is worse than showing one line too many. Only a price we can actually read is
     allowed to suppress anything. */
  function bnplEligible(price) {
    var L = BNPL_LIMITS;
    if (price === null) return { paypal: true, afterpay: true };
    return {
      paypal: price >= L.ppMin && price < L.ppMax,
      afterpay: price >= L.apMin && price < L.apMax
    };
  }

  /* ---- THE ACCEPTED PAYMENTS LIST OBEYS THE SAME BANDS (2026-08-21, Rishi: "yes please gate the
     Payments accordion also") ----
     ⚠️ Gated HERE rather than in Liquid, and that is not a shortcut. The list is rendered once per
     page load, but the price it is describing changes CLIENT-SIDE every time the shopper picks a
     differently-priced variant — the same reason `currentVariantPrice` reads the URL rather than
     trusting the rendered product. A Liquid-side gate would be right on load and wrong from the
     first size change.
     ⚠️ It also means the list and the instalment message can never disagree: one function, one set
     of limits, one call site.
     ⚠️ `querySelectorAll`, not `querySelector`: this block renders TWICE — the standalone copy the
     phone shows and the copy inside the desktop Payments accordion. Both are in the DOM at every
     width, one of them display:none, and both must be kept honest. */
  function syncPaymentsList(elig) {
    var set = function (sel, ok) {
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) nodes[i].hidden = !ok;
    };

    /* ⚠️ AFTERPAY IS GATED ON TWO THINGS, PRICE **AND** PRESENCE, and the second is the only reason
       this line is not a permanent hand-maintained claim. Shopify does not report Afterpay in
       `shop.enabled_payment_types` — it is a gateway from its own app, not a card brand or wallet —
       so Liquid renders the entry unconditionally and this is where it comes back out.

       The signal is the app's own `<square-placement>` anywhere in the document. If Afterpay is
       uninstalled or switched off, its app block stops rendering and the element is simply absent.
       ⚠️ PRESENCE, NOT VISIBILITY: the element is deliberately looked for across the whole document
       rather than checked for a non-zero box, because Afterpay's own app hides it on out-of-band
       products — that is a PRICE decision, and the price half is handled by `elig.afterpay`. Testing
       visibility here would conflate the two and make the entry vanish for the wrong reason.
       ⚠️ It is a proxy, not a fact. If the app is installed but failing to render for some other
       reason, this reads as "switched off". That is the safe direction — under-claiming a payment
       method rather than over-claiming one — and it is the only signal available. */
    var afterpayInstalled = !!document.querySelector("square-placement");

    set('[data-r-pay="paypal-payin4"]', elig.paypal);
    set('[data-r-pay="afterpay"]', elig.afterpay && afterpayInstalled);
  }

  function placeBnplMessage() {
    /* ---- BOTH PROVIDERS, ONE LINE (2026-08-18, Rishi: "I would like both afterpay and pay in 4 on
       the same line") ----
       This used to run on mobile only and to show exactly ONE provider, parking the other. Both of
       those are now gone: it runs at every width, and it puts Afterpay and PayPal in the same slot
       side by side.

       ⚠️ The note that used to sit here claimed desktop already had both messages in the buy column
       "under the size picker". Half true, and the misleading half cost a wrong diagnosis: they are
       both in the column but in DIFFERENT parents — Afterpay in its own `@app` block, PayPal nested
       inside <product-form> in the buy-buttons block — so they stack on separate rows and no
       stylesheet can pair them. Moving them into one slot is the only way they share a line.

       ⚠️ PayPal is found by ID, never by class. Its element carries no class at all, so a
       `[class*="paypal"]` probe reports zero and reads as "PayPal is missing on desktop". It is not. */
    const isNarrow = window.matchMedia("(max-width: 999px)").matches;

    /* Mobile hosts the slot in the sticky bar; desktop hosts it in the buy column's block list,
       inserted where Afterpay's own block already sits so the vertical order does not change. */
    const bar = isNarrow
      ? document.querySelector("product-sticky-add-to-cart")
      : document.querySelector(".product-info .product-info__block-list");
    if (!bar) return;

    /* Slot and park are appended to the BAR ITSELF, not inside its <product-rerender>. That child
       is what Shopify swaps on a variant change, so anything inside it is destroyed and rebuilt.
       <product-rerender> is `display: contents`, so the slot lands in a new grid row after the
       picker and Add to Cart. */
    let slot = bar.querySelector(":scope > [data-r-bnpl]");
    if (!slot) {
      slot = document.createElement("div");
      slot.setAttribute("data-r-bnpl", "");
      slot.className = "r-bnpl-bar";
      bar.appendChild(slot);
    }
    /* ---- desktop: BELOW the buy buttons (2026-08-18, Rishi: "center them under the ATC and Shop
       Buttons") ----
       It used to sit above them, between the size picker and Add to Cart. Anchored to the
       buy-buttons block rather than appended, because appending would drop it past the accordions at
       the very bottom of the column. Re-anchored on every run: a variant change rebuilds the block
       list around it, and a slot placed once would be orphaned at the end. */
    slot.classList.toggle("r-bnpl-bar--column", !isNarrow);
    if (!isNarrow) {
      const anchor = document.querySelector(
        '.product-info .product-info__block-item[data-block-type="buy-buttons"]'
      );
      if (anchor && anchor.nextElementSibling !== slot) {
        anchor.parentNode.insertBefore(slot, anchor.nextSibling);
      }
    }
    /* The unchosen provider is PARKED rather than deleted — both apps own their nodes and expect
       them to persist, and the shopper can switch to a variant that swaps which one is wanted. */
    let park = bar.querySelector(":scope > [data-r-bnpl-park]");
    if (!park) {
      park = document.createElement("div");
      park.setAttribute("data-r-bnpl-park", "");
      park.style.display = "none";
      bar.appendChild(park);
    }

    /* Identify by the element each app renders, never by block id — ids are generated per install
       and would silently stop matching after a reinstall.
       ⚠️ PayPal is collected as a LIST and the last one wins. Its node starts life inside
       <product-rerender>, so a variant change destroys it and the SDK injects a fresh one, which
       for a moment leaves the stale copy sitting in our slot alongside the new one. Taking the last
       in document order takes the newest and the old copy is parked — without this the bar can show
       a price from the previously selected variant. */
    var afterpay = null;
    document.querySelectorAll('[data-block-type="@app"]').forEach(function (b) {
      if (b.querySelector("square-placement")) afterpay = b;
    });
    var paypals = document.querySelectorAll('[id^="paypal-upstream-messaging"]');
    var paypal = paypals.length ? paypals[paypals.length - 1] : null;
    for (var i = 0; i < paypals.length - 1; i++) {
      if (paypals[i].parentElement !== park) park.appendChild(paypals[i]);
    }

    /* ---- WHO GETS SHOWN, AND WHY IT DIFFERS BY WIDTH ----
       Desktop shows BOTH side by side. The mobile ink bar keeps the original single pick, because
       two will not fit there legibly — measured at 375px: the pair squeezed to 148px and 187px, each
       wrapping to 70px tall, which grew the bar to 200px, a quarter of the screen, with Afterpay
       reading "or 4 payments of" and nothing after it. The bar is a fixed overlay; that height comes
       straight out of the page behind it.

       So `pickBnplProvider` is still the arbiter on narrow — it encodes the price band each provider
       actually covers — while desktop shows every provider that QUALIFIES, which may be two.

       🚨 REGRESSION FIXED 2026-08-21. This line read
           `: [afterpay, paypal].filter(Boolean)`
       from 2026-08-18 (commit 0210997, "both on one line") until today, and that bypassed the price
       bands entirely on desktop — the comment above even described the bypass as intentional, having
       confused "there is room for both" with "both are allowed here". Measured live before the fix:
       PayPal's message rendered on a $7,945 product and on a $15 one, against a documented band of
       $30–$1,500. 179 of 3,018 published in-stock products were affected. Mobile was always correct.
       ⚠️ Afterpay ALSO self-gates inside its own app, which is why only PayPal was visibly wrong —
       do not read that as "Afterpay needs no gate here". If their app ever stops doing it, this is
       the only thing standing behind it. */
    var bnplPrice = currentVariantPrice();
    var eligible = bnplEligible(bnplPrice);
    syncPaymentsList(eligible);

    var choice = pickBnplProvider(bnplPrice);
    var chosen = choice === "paypal" ? paypal : choice === "afterpay" ? afterpay : null;
    var wanted = isNarrow
      ? (chosen ? [chosen] : [])
      : [eligible.afterpay ? afterpay : null, eligible.paypal ? paypal : null].filter(Boolean);
    var show = wanted.length ? wanted[0] : null;

    /* ---- PayPal's message has to be restyled for the inverted bar (2026-08-14, Rishi: "I can
       barely read the text") ----
       It ships `text-color="grayscale"` at `text-size="10"`, which is fine on the white buy column
       the app was configured for and nearly invisible on ink. CSS cannot fix it: the message paints
       inside a CROSS-ORIGIN zoid iframe, so nothing in our stylesheet reaches it.

       What does reach it is the SDK's own config, which lives on the container as `data-pp-*`
       attributes — and the messaging component re-renders when they change (verified live:
       grayscale/10 -> white/12 produced a fresh render, iframe count unchanged).

       ⚠️ Set here rather than in the app's own settings on purpose. The app setting is global, and
       the SAME block sits in the white buy column on desktop, where `white` would be invisible.
       Setting it at the moment we move the node into the ink bar keeps the two contexts correct;
       desktop never reaches this code and keeps the app's own grayscale.

       ⚠️ Guarded so it only writes when the value actually differs. Every attribute write triggers
       a re-render, and this function runs on every variant change and mutation — writing blindly
       would re-render the widget several times per interaction. */
    /* ⚠️ The restyle below is for the INK BAR only. On desktop the same widget sits on the white buy
       column, where `white` is invisible — so desktop actively REMOVES the attributes rather than
       just skipping them. Skipping is not enough: a shopper who loads narrow and then widens (or
       rotates a tablet) would otherwise keep white-on-white text. */
    if (paypal && !isNarrow) {
      /* ⚠️ THE SIZE HAS TO BE AN ATTRIBUTE, not CSS: PayPal's message paints inside a cross-origin
         zoid iframe, so no stylesheet of ours can reach the text. 10 is the bottom of PayPal's
         documented 10–16 range (2026-08-18, Rishi: "can we make these smaller"). */

      /* ---- CENTRED, NOT CLEARED (2026-08-21, Rishi: "this is not looking centered") ----
         ⚠️ This used to REMOVE the attribute on desktop, on the reasoning that alignment "was the
         ink bar's business". That was wrong for a reason only visible on a long message: the widget
         sits in a FIXED 330px box, and its own content defaults to `text-align: start`. Whenever the
         copy wraps, the short second line hugs the left of that box and the whole message reads
         left-of-centre even when the box itself is centred perfectly.
         Measured on batwing-sleeve-knit-tweed-bomber ($2,976 — above PayPal's $1,500 ceiling, so it
         renders the longer generic "on purchases of $30–$1,500" copy): box 330px wide, content
         27px tall, i.e. two lines, ragged left-aligned inside it.
         ⚠️ Centring the BOX is not enough and is a separate fix — see the `[hidden]` rule in
         r-custom.css. Both were needed; either one alone still reads off-centre. */
      if (paypal.getAttribute("data-pp-style-text-align") !== "center") {
        paypal.setAttribute("data-pp-style-text-align", "center");
      }
      /* ---- NO PAYPAL BLUE ON THE BUY COLUMN (2026-08-18, Rishi: "I don't think the boss will
         like the blue from the logo or link text") ----
         ⚠️ `monochrome`, NOT `black`. They are not the same thing and `black` does not solve this:
         `black` colours the TEXT only and leaves the wordmark and the "Learn more" link in PayPal
         blue, which is the exact complaint. `monochrome` is the SDK's own single-ink mode — text,
         inline wordmark and link all render in one colour — and it is a documented, PayPal-
         sanctioned value (black | white | monochrome | grayscale), not a workaround. Their brand
         rules govern this asset, so the supported option is the only honest route.

         ⚠️ This slot renders `data-pp-style-logo-type="inline"`, which puts the word "PayPal" INSIDE
         the sentence rather than as a separate lockup — so the blue was inline with the copy and no
         amount of container CSS could have reached it. Same reason as the text size: the message
         paints in a cross-origin zoid iframe.

         ⚠️ It is SET here rather than left to the app's own setting. Desktop used to REMOVE this
         attribute, which is what let PayPal's default colour logo through in the first place — the
         old comment claimed desktop "keeps the app's own grayscale", and that was wrong: removing
         the attribute discards the app's value and falls back to the SDK default. Setting it
         explicitly also survives a shopper who loads narrow (where mobile writes `white`) and then
         widens without a reload. */
      if (paypal.getAttribute("data-pp-style-text-color") !== "monochrome") {
        paypal.setAttribute("data-pp-style-text-color", "monochrome");
      }
      if (paypal.getAttribute("data-pp-style-text-size") !== "10") {
        paypal.setAttribute("data-pp-style-text-size", "10");
      }
    }
    /* ⚠️ `chosen === paypal`, not merely "narrow and PayPal exists". Writing these attributes on a
       PARKED node still triggers the SDK to re-render it, which the original code avoided by only
       restyling the widget it was about to show. Matching that exactly keeps mobile's behaviour
       byte-for-byte what it was before the desktop work. */
    if (isNarrow && paypal && chosen === paypal) {
      /* `monochrome` since 2026-10-07: the bar is white again (Delinda: "not liking the black bg"), so the ink-bar `white` would be
         invisible; monochrome is the desktop's value (ink text, no PayPal blue). */
      if (paypal.getAttribute("data-pp-style-text-color") !== "monochrome") {
        paypal.setAttribute("data-pp-style-text-color", "monochrome");
      }
      /* 10 -> 10.5 (Rishi). ⚠️ PayPal's reference documents this attribute as WHOLE numbers 10–16,
         so a fraction is undocumented — but it is honoured rather than floored: measured on screen,
         10.5 renders visibly larger than 10. Being undocumented, it could start rounding without
         notice; the symptom would be the message shrinking back to its 10px size.
         ⚠️ It costs the single line. At 10 the whole message fits one row; at 10.5 "Learn more"
         wraps beneath. That is a real trade, not a rendering fault — 10 is the value to return to
         if the taller bar matters more than the half pixel. */
      if (paypal.getAttribute("data-pp-style-text-size") !== "10.5") {
        paypal.setAttribute("data-pp-style-text-size", "10.5");
      }
      /* ---- centred, to match Afterpay in the same slot (2026-08-14, Rishi) ----
         ⚠️ Centred with the SDK's OWN text-align, not by narrowing the box back down. The widget
         used to look centred only because it was stuck at 300px inside a 335px slot that centres
         its children — that "centring" was a side effect of being too narrow, and it cost 35px of
         width and wrapped the message onto two lines. The frame now fills the row and the text is
         centred INSIDE it, so it reads centred and still fits on one line.
         Ships empty from the app, which the SDK treats as left. */
      if (paypal.getAttribute("data-pp-style-text-align") !== "center") {
        paypal.setAttribute("data-pp-style-text-align", "center");
      }
    }

    /* Anything not wanted at this width is PARKED rather than removed — both apps own their nodes
       and expect them to persist, and a resize or variant change can make the other one wanted. */
    [afterpay, paypal].forEach(function (n) {
      if (n && wanted.indexOf(n) === -1 && n.parentElement !== park) park.appendChild(n);
    });
    /* Appended in a fixed order — Afterpay, then PayPal — so the desktop row never reshuffles
       between variants. The CSS bases in `.r-bnpl-bar--column` depend on this order. */
    wanted.forEach(function (n) { if (n.parentElement !== slot) slot.appendChild(n); });
    slot.hidden = !show;

    /* Only Afterpay needs the shadow-text watcher: it is the one that renders an empty element
       carrying its own margins when it declines to show a message. PayPal is chosen only inside a
       band where it always renders, and its state is unreadable anyway. */
    /* ⚠️ WHAT gets collapsed depends on who else is in the row. Afterpay renders an empty element
       still carrying its own box when the price is outside its limits. On narrow it is the slot's
       only occupant, so the slot collapses, exactly as before. On desktop PayPal shares the row, so
       collapsing the slot would take PayPal down with it on the 57 live products priced over
       Afterpay's cap — there, only Afterpay's own cell collapses. */
    if (afterpay && wanted.indexOf(afterpay) !== -1) {
      watchAfterpayHeight(isNarrow ? slot : afterpay, afterpay);
    }
  }

  // Old name kept as an alias so nothing that still calls it silently stops working.
  function placeAfterpayMessage() { placeBnplMessage(); }

  /* Afterpay renders NOTHING when the price is outside its limits (the app's
     `show_if_outside_limits` setting, turned off 2026-08-12) — but its element still carries its
     own 16px mobile margins, leaving a dead gap above the brand on the 57 live products priced over
     the cap. Collapsing the slot removes it.

     ⚠️ The signal is SHADOW CONTENT, not height, and that distinction is load-bearing. Measuring
     height and hiding on zero is self-defeating: hiding the slot makes the widget unmeasurable, so
     it can never report a height again and the slot latches hidden forever — including on products
     where the message should show. That bug shipped for one push and hid the widget on a $675
     product. Reading the shadow root does not depend on layout, so it keeps working while hidden.

     ⚠️ The test is shadow TEXT, not the presence of a child element. Suppressed, Afterpay still
     renders a child — an empty <div> — so "has a non-style child" is true in both states and hides
     nothing. Measured: shown gives <p> with "or 4 payments of …"; suppressed gives <div> with zero
     characters. */
  const afterpayWatched = new WeakSet();
  /* `target` is the node to collapse when Afterpay declines to render — its own cell, not the shared
     row. See the call site for why that distinction became load-bearing once PayPal joined the row. */
  function watchAfterpayHeight(target, block) {
    const placement = block.querySelector("square-placement");
    if (!placement || afterpayWatched.has(placement)) return;
    afterpayWatched.add(placement);

    const hasMessage = () => {
      const root = placement.shadowRoot;
      if (!root) return false;
      return Array.from(root.children)
        .filter((n) => n.tagName !== "STYLE")
        .some((n) => n.textContent.trim().length > 0);
    };
    const sync = () => { target.hidden = !hasMessage(); };

    // The shadow root does not exist until the app hydrates, and there is no event for that, so
    // poll briefly to attach the real observer and stop. Bounded so a failed script cannot leave a
    // timer running for the life of the page.
    let attempts = 0;
    (function attach() {
      sync();
      if (placement.shadowRoot) {
        new MutationObserver(sync).observe(placement.shadowRoot, { childList: true, subtree: true });
        return;
      }
      if (attempts++ < 40) setTimeout(attach, 150);
    })();
  }

  placeAfterpayMessage();

  let bnplQueued = false;
  const bnplObserver = new MutationObserver(() => {
    // Debounced to one run per frame: Shopify emits several mutations per variant change, and
    // re-running the move on each one would thrash the node the app is still hydrating.
    if (bnplQueued) return;
    bnplQueued = true;
    requestAnimationFrame(() => {
      bnplQueued = false;
      placeAfterpayMessage();
      /* The tabs are inside <product-rerender> too, so a variant change destroys the sliding
         marker along with them. Rebuilt on the same debounced frame rather than its own observer. */
      syncTabMarker();
      /* Same reason: the description is re-rendered from the server on a variant change, so the
         trailing blank paragraphs come straight back. Re-strip on the same frame. */
      stripDescriptionTail();
      /* And the accordion: a variant change re-renders `<r-tabs>` from the server, which brings
         back the Liquid's always-one-open state and the tab ARIA. The `data-r-acc-ready` guard
         makes this a no-op when the markup survived. */
      initColumnAccordion();
    });
  });

  /* ⚠️ GUARD, and it fixes a real bug rather than being defensive for its own sake. This file's
     DOMContentLoaded handler runs on EVERY template, and `.shopify-section--main-product` exists
     only on a product page — so on collections, cart, search and the FAQ, `observe(null)` threw
     "parameter 1 is not of type 'Node'" and **aborted the rest of this handler**, taking every
     listener registered below it with it. Found in the console while debugging the tab marker;
     it had been failing silently on every non-product page. */
  if (productSection) {
    bnplObserver.observe(productSection, {
      childList: true,
      subtree: true
    });
  }

    
});
/* ============================================================================
   GALLERY: PINCH TO ZOOM IN PLACE  (2026-08-14, Rishi)

   "Remove the click to fullscreen option… let the user zoom with their fingers,
   and when they pinch back it goes back to fixed width."

   ⚠️ THE THEME HAS TWO ROUTES INTO FULLSCREEN, not one, and only one of them is
   a click. Found in theme.js:
     · <open-lightbox-button> dispatches `lightbox:open` on click.
     · ProductGallery binds `gesturestart` whenever it carries `allow-zoom`, and
       its `gesturechange` handler opens the lightbox as soon as event.scale
       passes 1.5. So on iOS a PINCH already opened fullscreen — which is exactly
       the gesture we are repurposing. Removing only the button would have left
       the pinch still firing the thing it was meant to replace.

   ⚠️ NOT done by turning off `enable_image_zoom` in product.json, which is the
   one-line version and is wrong: that setting is section-wide, so it would strip
   the zoom button and lightbox from DESKTOP too, where click-to-zoom is a normal
   pattern and is staying. Everything here is scoped to the mobile breakpoint.

   Both gesture events are cancelled in the CAPTURE phase on the gallery. The
   theme's listeners sit on the carousel INSIDE it, so stopping propagation on
   the ancestor beats them to it without unbinding anything or depending on the
   order the two scripts happen to run in.

   Zoom is applied to the <img> as a transform inside an overflow-hidden media
   box, so a zoomed image is clipped to its own frame and neither the page nor
   the neighbouring images move — "zoom in place" in the literal sense.

   ⚠️ A ZOOMED PHOTO ALWAYS HAS A WAY OUT (fix 2026-10-08, freeze investigation, MASTER_LIST C-37).
   While zoomed the photo takes `touch-action: none` and a one-finger drag pans the picture, so on a
   phone, where the photo fills most of the first screen, a zoom nobody meant reads as a frozen page:
   no scroll, no next photo. It used to latch at any spread over 5% (an accidental second finger is
   enough, and at 1.1x the photo looks unzoomed), it survived Back, and only a pinch back in or a
   refresh undid it. Reproduced in real iPhone Safari. Now:
     · released under 1.3x, the photo springs back to fixed width (SNAP_BACK_AT);
     · a double-tap on a zoomed photo puts it back;
     · it resets once the photo is mostly off screen: the page scrolled past it, or the gallery moved
       to another photo (a variant change selects its own photo);
     · and on a back/forward-cache restore (`pageshow`).
   A deliberate zoom (1.3x and up) is unchanged: spread to zoom, pan with one finger, pinch back in.
   ============================================================================ */
document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("page-product")) return;

  const gallery = document.querySelector("product-gallery");
  if (!gallery) return;

  const isMobile = () => window.matchMedia("(max-width: 999px)").matches;
  const MAX_SCALE = 3;          /* matches the theme's own max_image_zoom_level */
  const SNAP_BACK_AT = 1.3;     /* released under this, it springs back (was 1.05, a hair above 1, which
                                   latched an accidental 1.1x zoom: see "A ZOOMED PHOTO ALWAYS HAS A WAY OUT") */

  ["gesturestart", "gesturechange", "gestureend"].forEach((type) => {
    gallery.addEventListener(type, (event) => {
      if (!isMobile()) return;
      event.preventDefault();
      event.stopPropagation();
    }, { capture: true });
  });

  /* The ways out that are not a pinch (2026-10-08, see the header). Each photo registers its reset;
     one observer serves them all. It only reads, and a photo is only written to when it IS zoomed, so
     a swipe through unzoomed photos costs nothing: no DOM insertion, no forced layout (the progress
     line's first-swipe rule). "Mostly off screen" = under a quarter of the photo showing.
     ⚠️ TWO thresholds, not one (review, 2026-10-08). On a phone held sideways the photo is taller than
     the screen: on load only 0.24 of it shows while it fills two thirds of the screen, so a lone 0.25
     is never crossed on the way out and a zoom made there never reset, neither by scrolling past nor
     by the gallery moving on. And a photo the gallery has just moved past sits exactly edge to edge
     with the carousel, which the observer still counts as intersecting at ratio 0, so 0 would not
     fire for it either. 0.01 catches both. */
  const resets = new WeakMap();
  const offscreen = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.intersectionRatio < 0.25) resets.get(entry.target)?.(true); });
  }, { threshold: [0.01, 0.25] }) : null;
  /* Safari keeps the page, zoom and all, in the back/forward cache (seen on Back in real iPhone Safari):
     put the photo back the moment the page is shown again. */
  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;
    document.querySelectorAll(".product-gallery__media").forEach((media) => resets.get(media)?.(false));
  });

  const setup = (media) => {
    if (media.dataset.rPinch === "on") return;
    if (media.getAttribute("data-media-type") !== "image") return;
    const img = media.querySelector("img");
    if (!img) return;
    media.dataset.rPinch = "on";

    /* ---- resolution: upgrade the source the first time this image is pinched ----
       Rishi, 2026-08-14: "when I zoom in I feel like the images being served are not
       [high resolution]". Correct, and the masters were never the problem — they are
       2000x2500. The browser simply downloads the fit-to-screen variant, because that is
       all `sizes` asks for: "(max-width: 699px) 100vw" resolves to the phone's width, so
       a 375pt slot at DPR 2 fetches the 800w candidate. Magnify that 3x and there is
       nothing behind it.

       Fixed by rewriting `sizes` rather than `src`: srcset is still the selector, so the
       browser re-runs its own candidate pick and lands on the largest offered (2000w).
       Setting `src` directly would be ignored while a srcset is present.

       Once per image, and only on a real pinch — eagerly upgrading eight full-width
       images would pull megabytes for a gesture most shoppers never make. Not reverted
       on zoom-out either: the file is cached by then, and dropping back would only buy a
       re-download the next time they pinch. */
    let upgraded = false;
    const upgradeSource = () => {
      if (upgraded || !img.getAttribute("srcset")) return;
      upgraded = true;
      img.sizes = "2000px";
    };

    const pointers = new Map();
    let scale = 1, tx = 0, ty = 0;
    let startDist = 0, startScale = 1, startTx = 0, startTy = 0, startMidX = 0, startMidY = 0;
    let panId = null, panFromX = 0, panFromY = 0;
    let tap = null, lastTap = null;   /* double-tap to reset, see lift() */

    const paint = (animated) => {
      img.style.transition = animated ? "transform 0.22s ease" : "";
      img.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
      /* While zoomed the finger has to pan the IMAGE, so the browser must stop
         claiming the drag for page scroll. Released the moment we are back to 1. */
      media.style.touchAction = scale > 1 ? "none" : "";
      media.classList.toggle("r-pinch--zoomed", scale > 1);
    };

    /* Keep the image covering its frame: at scale s the overhang each way is
       (size*s - size)/2, and panning past that would expose a strip of nothing. */
    const clamp = () => {
      const r = media.getBoundingClientRect();
      const maxX = Math.max(0, (r.width * scale - r.width) / 2);
      const maxY = Math.max(0, (r.height * scale - r.height) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    };

    const settle = (animated = true) => { scale = 1; tx = 0; ty = 0; paint(animated); };

    /* For the observer and `pageshow` above: drop any gesture in flight (a finger that was down when the
       page went into the back/forward cache never sends its pointerup) and, if zoomed, go back to 1. */
    resets.set(media, (animated) => {
      pointers.clear(); startDist = 0; panId = null; tap = lastTap = null;
      if (scale > 1) settle(animated);
    });
    if (offscreen) offscreen.observe(media);

    media.addEventListener("pointerdown", (event) => {
      if (!isMobile() || event.pointerType === "mouse") return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      tap = pointers.size === 1 ? { x: event.clientX, y: event.clientY, t: event.timeStamp } : null;

      if (pointers.size === 2) {
        upgradeSource();
        const [a, b] = [...pointers.values()];
        startDist = Math.hypot(b.x - a.x, b.y - a.y);
        startScale = scale; startTx = tx; startTy = ty;
        startMidX = (a.x + b.x) / 2; startMidY = (a.y + b.y) / 2;
        panId = null;
      } else if (pointers.size === 1 && scale > 1) {
        panId = event.pointerId;
        panFromX = event.clientX - tx;
        panFromY = event.clientY - ty;
      }
    });

    media.addEventListener("pointermove", (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (tap && Math.hypot(event.clientX - tap.x, event.clientY - tap.y) > 10) tap = null;

      if (pointers.size >= 2 && startDist) {
        event.preventDefault();
        const [a, b] = [...pointers.values()];
        const dist = Math.hypot(b.x - a.x, b.y - a.y);
        scale = Math.min(MAX_SCALE, Math.max(1, startScale * (dist / startDist)));
        /* Track the midpoint so the picture follows the fingers rather than
           pivoting around its own centre while they move across it. */
        const midX = (a.x + b.x) / 2, midY = (a.y + b.y) / 2;
        tx = startTx + (midX - startMidX);
        ty = startTy + (midY - startMidY);
        clamp();
        paint(false);
      } else if (panId === event.pointerId && scale > 1) {
        event.preventDefault();
        tx = event.clientX - panFromX;
        ty = event.clientY - panFromY;
        clamp();
        paint(false);
      }
    }, { passive: false });

    const lift = (event) => {
      pointers.delete(event.pointerId);
      if (panId === event.pointerId) panId = null;
      if (pointers.size < 2) startDist = 0;
      /* Pinching back in returns to fixed width, and so does any release under SNAP_BACK_AT (1.3x, fix
         2026-10-08). Only once every finger is off, so a two-finger gesture that dips under 1 mid-pinch
         can still recover. */
      if (pointers.size === 0 && scale < SNAP_BACK_AT) settle();
      /* Double-tap on a ZOOMED photo = back to fixed width (2026-10-08). A tap is one finger, up within
         300ms, moving under 10px; the second must start within 300ms of the first ending, near it. An
         unzoomed photo still does nothing on a tap (Delinda, 2026-08-14, "TAP AN IMAGE FOR FULLSCREEN"). */
      if (event.type === "pointerup" && tap && pointers.size === 0 && event.timeStamp - tap.t < 300) {
        const second = lastTap && tap.t - lastTap.t < 300 && Math.hypot(tap.x - lastTap.x, tap.y - lastTap.y) < 40;
        lastTap = second ? null : { x: tap.x, y: tap.y, t: event.timeStamp };
        if (second && scale > 1) settle();
      }
      tap = null;
    };
    media.addEventListener("pointerup", lift);
    media.addEventListener("pointercancel", lift);
  };

  const scan = () => gallery.querySelectorAll(".product-gallery__media").forEach(setup);
  scan();

  /* The gallery is re-rendered on a variant change, so newly inserted media need
     binding too. The data-r-pinch guard makes a re-scan cheap and idempotent. */
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(gallery, { childList: true, subtree: true });
});

/* ============================================================================
   DESKTOP: SCROLL-AWARE STICKY BUY COLUMN   (2026-08-18, Rishi: "I need a
   solution to pin the right column and am now open to suggestions")
   ----------------------------------------------------------------------------
   The gallery is a 7,153px image tower beside an 841px buy column. Left alone,
   the size picker and Add to Cart are off screen for roughly 6,300px of scroll.

   ⚠️ RETRACTION, SAME DAY. An earlier version of this comment stated that the
   theme's `<safe-sticky>` "does not work on this store" and called it verified.
   That was wrong and the evidence was worthless. ROOT CAUSE, pinned down later
   the same day: the automation's browser pane was HIDDEN, and a hidden document
   has its entire rendering clock frozen — measured directly,
   `document.hidden === true` and `document.timeline.currentTime` advanced 0ms
   across a real wall-clock second. No rAF, no scroll events, no CSS animation
   ticks. A page-world listener counted 0 scroll events across scrolls of
   0 → 3,000 → 0 while one real mouse wheel produced 2. Under that instrument
   EVERY time-or-scroll-driven behaviour on the site reads as dead — the
   vendor's, this one's, and any animation you go on to write.

   ⚠️ THE TEST THAT TELLS YOU: read `document.hidden` and sample
   `document.timeline.currentTime` twice a second apart. If it has not moved,
   nothing you are about to measure means anything. Re-open the pane first.

   ⚠️ SO WHY KEEP THIS RATHER THAN USE `<safe-sticky>`? Two real differences that
   stand on their own, independent of whether the vendor's ever engages:
     1. It clamps against a bare `window.innerHeight`, which knows nothing about
        the 92px of sticky header + crumb bar above this column — so its floor
        lets the column slide up BEHIND fixed chrome.
     2. Its floor is `height - innerHeight + 20` unconditionally, so a column
        that already fits still drifts ~53px up and back on every direction
        change. This one collapses the range in that case and simply holds.
   Both are corrections to the vendor's arithmetic, not a rewrite of its idea.

   ⚠️ THE DRIFT ITSELF IS UNVERIFIED. What is confirmed with real input is that
   the column pins at the chrome line and Add to Cart stays on screen at every
   scroll depth — but that is native `position: sticky` doing the work, and it
   needs none of this. The travel-to-reveal-the-end behaviour below could not be
   exercised here for the reason above. Check it with a real wheel before
   claiming it works.

   ⚠️ WHY NOT PLAIN `position: sticky` ALONE. The column does not fit. 841px
   against 808px of space at 1440x900, and roughly 150px short on a 13" laptop.
   Native sticky pins the TOP, so the column's own bottom — the accordion — sits
   permanently below the fold at every scroll position.

   WHAT IT DOES. Exactly what the vendor intended, plus two corrections:
     scroll down -> the column travels up, but no further than the point where
                    its last pixel is 20px above the viewport bottom
     scroll up   -> it returns to the chrome line immediately
   The two corrections over the vendor's version are (1) it measures the sticky
   HEADER AND CRUMB BAR and pins below them, where the vendor clamps against a
   bare `innerHeight` and lets the column slide behind fixed chrome, and (2) when
   the column genuinely fits it does not drift at all — the vendor's floor is
   `innerHeight - height - 20` unconditionally, which walks a short column 53px
   up under the bar and back on every direction change.
   ============================================================================ */
document.addEventListener("DOMContentLoaded", function () {
  var col = document.querySelector(".shopify-section--main-product .r-col-stack");
  if (!col) return;

  var mq = window.matchMedia("(min-width: 1000px)");
  var chrome = 0;      /* header + crumb bar, measured */
  var colH = 0;
  var lastY = window.scrollY;
  var currentTop = 0;
  var queued = false;

  /* ⚠️ Measured, not hard-coded. `--header-height` exists but the crumb bar has
     no equivalent, and its height is padding + line-height — i.e. it moves the
     moment anyone retunes the bar's type, which has already happened three times
     this week. Reading the DOM keeps the two in step for free. */
  function measureChrome() {
    var header = document.querySelector(".shopify-section--header");
    var bar = document.querySelector(".r-crumb-bar");
    var h = header ? header.offsetHeight : 0;
    /* offsetHeight is 0 when the bar is display:none, which is exactly right —
       below 1000px there is no bar to clear, and we are not running there anyway. */
    var b = bar ? bar.offsetHeight : 0;
    /* ⚠️ THE PINNED BREADCRUMBS ARE CHROME TOO (2026-10-16, Rishi: "right now this scrolls when the page scrolls. I would like it to
       be fixed on desktop. I would also like the breadcrumbs to be sticky on desktop"). The product page's breadcrumb bar
       (`.r-crumbs-top`, under the header since Oct 7) now pins under the header from 1000px as well (r-custom.css "THE PRODUCT
       PAGE'S BREADCRUMBS STICK ON DESKTOP TOO"), so the column rests under it. Before, the bar scrolled away, the space the column
       centres in grew by its 43px, and the column slid up (22px at 1440x900, under the header on short windows). Counted here, that
       space never changes, so a column that fits rests at one height for the whole page: fixed. Only while it is actually sticky. */
    var crumbs = document.querySelector(".r-crumbs-top");
    if (crumbs && getComputedStyle(crumbs).position === "sticky") b += crumbs.getBoundingClientRect().height;
    return h + b;
  }

  /* The resting top: centred in the space under the header when the column fits, the chrome line when it does not. */
  /* ⚠️ CENTRED UNDER WHATEVER IS ABOVE THE GRID (2026-10-07): the breadcrumb bar now sits between the header and the gallery and
     scrolls away, so at the top of the page the space to centre in starts at the grid's top, not at the header; once the bar has
     scrolled off, the grid's top is above the header and `chrome` takes over again, exactly as before. */
  function restTop() {
    var top = Math.max(chrome, col.parentElement.getBoundingClientRect().top);
    return top + Math.max(0, (window.innerHeight - top - colH) / 2);
  }

  /* ⚠️ RESETS TO THE RESTING POSITION, NOT THE CHROME LINE (2026-10-01, Rishi: "when I resize the page the content area seems to
     jump back to the top of the page"). Since the column rests centred, a reset that parked it at `chrome` threw it to the top
     on every window resize, and nothing moved it back until the next scroll. It now re-measures and lands on the new centre. */
  function reset() {
    chrome = measureChrome();
    colH = col.offsetHeight;
    currentTop = restTop();
    lastY = window.scrollY;
    col.style.top = Math.round(currentTop) + "px";
  }

  function update() {
    /* ⚠️ THE RESTING POSITION IS CENTRED, NOT THE CHROME LINE (2026-10-01, Rishi, with a screenshot of Louis Vuitton's PDP: "lv's
       content area is vertically centered and it grows vertically when an accordion or some other revealing element is clicked.
       Can we do the same?"). When the column fits, `maxTop` is the top that centres it in the space under the header, so it rests
       in the middle of the window; the ResizeObserver below calls this on every height change (an accordion, Read More), so it
       re-centres frame by frame and grows evenly up and down. A column taller than that space gets `chrome` as before, and the
       travel-to-reveal-its-end behaviour is unchanged. Centring moves `top` only — the column keeps its own height — so a short
       gallery is never stretched; sticky simply stops at the bottom of the product row. */
    var maxTop = restTop();
    var minTop = window.innerHeight - colH - 20;
    /* Column fits the viewport: collapse the range so there is nothing to drift
       through. Without this a short column slides up under the crumb bar and
       back every time the shopper changes direction. */
    if (minTop > maxTop) minTop = maxTop;

    var y = window.scrollY;

    /* ⚠️ Nothing is stuck until the grid's own top edge reaches the chrome line.
       Before that the column is simply in flow, and letting `currentTop` drift
       down during that stretch means it arrives already parked at its floor —
       the column would appear pre-scrolled the instant it stuck. */
    var gridTop = col.parentElement.getBoundingClientRect().top;
    if (gridTop >= chrome) {
      currentTop = maxTop;
    } else {
      currentTop += lastY - y;          /* down -> shrink, up -> grow */
      if (currentTop < minTop) currentTop = minTop;
      if (currentTop > maxTop) currentTop = maxTop;
    }

    lastY = y;
    col.style.top = Math.round(currentTop) + "px";
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }

  function enable() {
    reset();
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  function disable() {
    window.removeEventListener("scroll", onScroll);
    col.style.removeProperty("top");
  }

  /* The column's height is not constant: opening SHIP/RETURN roughly doubles it,
     and a variant change rebuilds the block list underneath. Re-measuring the
     HEIGHT without resetting `currentTop` keeps the pin where the shopper left
     it instead of snapping the column back under their cursor. */
  if (window.ResizeObserver) {
    new ResizeObserver(function () {
      if (!mq.matches) return;
      colH = col.offsetHeight;
      update();
    }).observe(col);
  }

  /* Re-centred once per frame while the window is being dragged (`update` applies the clamps and the scrolled-past cases). */
  var resizeQueued = false;
  window.addEventListener("resize", function () {
    if (!mq.matches || resizeQueued) return;
    resizeQueued = true;
    requestAnimationFrame(function () { resizeQueued = false; reset(); update(); });
  });

  if (mq.matches) enable();
  mq.addEventListener("change", function (e) {
    if (e.matches) enable(); else disable();
  });
});

/* ============================================================================
   MOBILE: REVEAL THE COLLECTION DESCRIPTION'S "READ MORE" ONLY WHEN IT IS NEEDED
   (2026-08-27, Rishi: "add a 'read more' link after about 3 lines of text that will reveal the
   rest of the description")
   ----------------------------------------------------------------------------
   The clamp itself is CSS (`max-height: 3lh` under 1600px; under 1000px until 2026-09-25). All this does is decide whether the
   control is worth showing, because CSS cannot ask "did that overflow?".

   ⚠️ THE BUTTON'S LABEL IS RENDERED IN LIQUID, NOT HERE, and deliberately: it uses the theme's own
   `blog.general.read_more` string, so it localises with the rest of the storefront and no new
   shopper-facing copy is invented in a script. This file only toggles `hidden`.

   ⚠️ IT TOGGLES BOTH WAYS (2026-08-27, Rishi: "add the read less button"). BOTH labels are in the
   markup and CSS shows one based on `aria-expanded` — this file never touches text, so no
   storefront copy is buried in a behaviour script.
   ⚠️ "Read less" is HARDCODED in the template while "Read more" reads `blog.general.read_more`,
   and that asymmetry is knowing rather than sloppy: the locale file has no less/hide/collapse
   string, the storefront publishes a single locale (no `hreflang` alternates are emitted), and
   adding a key to an auto-generated file that Shopify's language editor rewrites would be the
   fragile option. If a second locale is ever published, that word is the thing to fix.
   ============================================================================ */
document.addEventListener("DOMContentLoaded", function () {
  var desc = document.querySelector(".collection-description");
  var btn = document.querySelector(".collection-readmore");
  if (!desc || !btn) return;

  /* ⚠️ EVERY WIDTH since 2026-10-01 (Rishi: "3 for the collection pages"; was up to 1599px from 2026-09-25, 999px before). Must
     match the clamp in r-custom.css, which is no longer inside a width query, or the button and the clamp disagree. "all" keeps
     the matchMedia plumbing below unchanged. */
  var mq = window.matchMedia("all");

  /* ⚠️ `+ 1` of slack, and it is not superstition. `scrollHeight` is rounded UP and `clientHeight`
     is rounded, so a description that fits exactly can report a 1px overflow and offer a button
     that expands nothing — the same sub-pixel mismatch that produced a phantom scrollbar in the
     PDP's buy column. */
  function overflows() {
    return desc.scrollHeight > desc.clientHeight + 1;
  }

  function sync() {
    if (!mq.matches) { btn.hidden = true; return; }
    /* ⚠️ WHILE EXPANDED THE BUTTON MUST STAY, and the measurement must NOT be consulted. An
       expanded element has no overflow by definition, so `overflows()` returns false and would
       hide the very control that collapses it — stranding the reader in the long version with no
       way back. This early return is the whole reason the toggle survives a resize. */
    if (desc.classList.contains("is-expanded")) { btn.hidden = false; return; }
    btn.hidden = !overflows();
  }

  /* ⚠️ BOTH DIRECTIONS ANIMATE BETWEEN TWO REAL LENGTHS, and that is the entire fix for the jerk.
     The CSS end state is `max-height: none`; `none` is a keyword, so a transition to or from it has
     nothing to interpolate and the browser hard-cuts. Pinning `scrollHeight` in pixels for the
     duration of the toggle gives it two numbers to move between, and clearing the inline value on
     `transitionend` hands control back to the stylesheet so a later content change is not clipped
     by a stale pixel cap.
     ⚠️ The reflow read between setting and clearing is load-bearing on collapse: without forcing
     layout, the browser coalesces "pin to 277px" and "drop to 3lh" into one frame and there is no
     start value to animate from — the same hard cut, just written more elaborately. */
  function setHeightForTransition(px) {
    desc.style.maxHeight = px + "px";
  }

  desc.addEventListener("transitionend", function (e) {
    if (e.propertyName !== "max-height") return;
    /* Only the expanded state wants the cap gone; collapsed keeps the stylesheet's 3lh. */
    if (desc.classList.contains("is-expanded")) desc.style.maxHeight = "";
  });

  btn.addEventListener("click", function () {
    var expanding = !desc.classList.contains("is-expanded");

    if (expanding) {
      /* Measured OPEN (2026-10-07): closed, the paragraphs run on with no gap (r-custom.css "NO PARAGRAPH GAP WHILE THE
         DESCRIPTION IS CLOSED"), so the closed scrollHeight is short by those gaps and the reveal used to stop short and snap.
         Pin today's height, switch to the open state (gaps back; the pin keeps the box still), then measure and animate to it. */
      setHeightForTransition(desc.clientHeight);
      void desc.offsetHeight;
      desc.classList.add("is-expanded");
      setHeightForTransition(desc.scrollHeight);
    } else {
      setHeightForTransition(desc.scrollHeight);
      void desc.offsetHeight;                 /* force layout so the pin is a real start value */
      desc.classList.remove("is-expanded");
      desc.style.maxHeight = "";              /* animates back to the stylesheet's 3lh */
    }

    btn.setAttribute("aria-expanded", expanding ? "true" : "false");
  });

  sync();
  /* Fonts land after first paint and change the line count, so one late re-measure. Without it a
     description that overflows only once the webfont applies would never get its control. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  window.addEventListener("resize", sync);
  mq.addEventListener("change", sync);
});

/* ============================================================================
   PDP GALLERY: THE PROGRESS LINE  (2026-10-07, Rishi: "use the thin progress line like the product cards.")
   ----------------------------------------------------------------------------
   The phone gallery swipes sideways since the same day (r-custom.css "MOBILE PDP = HORIZONTAL SWIPE GALLERY"), with
   nothing to say which photo is on show. This draws the product cards' progress line on it, with the cards' rules
   (assets/r-card-carousel.js, 2026-09-24/25) and their CSS class, so the two read as one thing:
   - a 2px line at the BOTTOM of the photo (r-custom.css, Rishi 2026-10-07), white blended with `difference` (dark over the pale
     stage, light over a black garment), grown to photo k of n = k/n of the width with `transform` (r-custom.css `.r-card-progress`);
   - VISIBLE FROM PAGE LOAD, at 1/n on photo 1, and it never fades (2026-10-08, Rishi after speaking with Delinda: "I would like
     the progress indicator for the gallery to persist. It should not disappear." · "I would like the line to be visible on page
     load"). It used to wait for the first move off photo 1 and fade 3 s after the last move, as the cards' line still does.
   - KEPT CLEAR OF THE STICKY BAR (same request). The gallery is the photo's natural height and the phone's Add to Cart bar is
     fixed to the bottom of the screen, so on the first screen the bar usually covers the bottom of the photo (by 2px on a
     390×844 iPhone, by far more on shorter phones), and the line with it. While the bar overlaps the photo the line rides just
     above the bar's top edge; as the page scrolls the photo up past the bar it settles back on the photo's bottom edge. The
     lift uses the separate CSS `translate` property, so the width's `transform` transition never animates it, and it is only
     written when the overlap changes (page scroll / resize / the bar's own height, one read per animation frame).
   Phones and tablets only (max-width 999px), where the gallery is the swipe carousel; desktop's grid never scrolls
   sideways, and r-custom.css hides the line from 1000px in case a window is widened after it was drawn.
   The host is `.product-gallery__image-list` (made the positioning box and an isolation group in r-custom.css): the
   carousel itself is the scroller, and a line inside it would scroll away with the photos.
   No-click rule (Delinda, 2026-08-14): the line is display-only, `aria-hidden`, `pointer-events: none`.
   ============================================================================ */
(() => {
  const mq = window.matchMedia("(max-width: 999px)");
  const SEL = ".shopify-section--main-product scroll-carousel";
  let bar = null;
  let shown = -1;

  const slides = (c) => [...c.querySelectorAll(".product-gallery__media")].filter((s) => !s.hidden);
  const photoAt = (c, n) => Math.max(0, Math.min(n - 1, Math.round(c.scrollLeft / (c.clientWidth || 1))));

  // Kept clear of the fixed Add to Cart bar (see the header). One measurement per animation frame at most.
  let lifted = 0;
  let queued = false;
  const lift = () => {
    queued = false;
    if (!bar || !bar.isConnected) return;
    let up = 0;
    const sticky = mq.matches && document.querySelector("product-sticky-add-to-cart");
    if (sticky) {
      const s = sticky.getBoundingClientRect();
      const h = bar.parentElement.getBoundingClientRect();
      // Only when the bar's top edge falls INSIDE the photo: below it nothing is covered, above it the line can't show anyway.
      if (s.height > 0 && s.top > h.top && s.top < h.bottom) up = Math.ceil(h.bottom - s.top);
    }
    if (up === lifted) return;
    lifted = up;
    bar.style.translate = up ? `0 ${-up}px` : "";
  };
  const queueLift = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(lift);
  };

  /* ⚠️ THE LINE IS BUILT BEFORE ANY SWIPE, NEVER DURING ONE (fix, 2026-10-07 evening, Delinda: "On the first swipe, it abruptly
     stops in the middle of the 2'nd photo. You have to go back / forward to make it smooth"). The first version created the line
     inside the scroll handler at the moment the first swipe crossed the middle of photo 2, and read its box to commit it; on iOS
     Safari inserting an element next to the scroller in mid-momentum (plus that forced layout) cancels the snap, so the photos
     stopped half-way. Reproduced in real Safari (iOS 26 simulator) and fixed by building the line as soon as the page is ready
     (and again on touchstart if a re-render dropped it); the scroll handler only changes its transform (compositor-only) and
     never creates it. Since 2026-10-08 it is built already showing, at the photo on show (1/n at load), with that width set
     BEFORE it is inserted, so it doesn't grow in from nothing. */
  const ensure = () => {
    if (!mq.matches) return;
    if (bar && bar.isConnected) return;
    const c = document.querySelector(SEL);
    const host = c && c.closest(".product-gallery__image-list");
    const n = c ? slides(c).length : 0;
    if (!host || n < 2) return;
    bar = document.createElement("span");
    bar.className = "r-card-progress r-gal-progress";
    bar.setAttribute("aria-hidden", "true");
    shown = photoAt(c, n);
    bar.style.transform = `scaleX(${(shown + 1) / n})`;
    lifted = 0;
    host.appendChild(bar);
    queueLift();
  };

  const update = (c) => {
    if (!mq.matches || !bar || !bar.isConnected) return; // built at load / touchstart only, never mid-swipe (see above)
    const n = slides(c).length;
    if (n < 2) return;
    const i = photoAt(c, n);
    if (i === shown) return; // still on the same photo: nothing to redraw
    shown = i;
    bar.style.transform = `scaleX(${(i + 1) / n})`;
  };

  document.addEventListener("scroll", (event) => {
    const c = event.target;
    if (c instanceof Element && c.matches(SEL)) update(c);
  }, { passive: true, capture: true });
  // The page's own scroll moves the photo against the fixed bar (bubbling from document only, not the gallery's sideways scroll).
  window.addEventListener("scroll", queueLift, { passive: true });
  window.addEventListener("resize", queueLift, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener("resize", queueLift, { passive: true });
  const sticky = document.querySelector("product-sticky-add-to-cart");
  if (sticky && "ResizeObserver" in window) new ResizeObserver(queueLift).observe(sticky); // its rows fold away as the page scrolls

  document.addEventListener("touchstart", (event) => {
    if (!event.target.closest?.(SEL)) return;
    ensure(); // a re-rendered section dropped the line: rebuild it now, before this touch can start a scroll
  }, { passive: true, capture: true });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ensure);
  else ensure();
  mq.addEventListener("change", ensure);
})();

/* ============================================================================
   PDP GALLERY: THE SWIPE HINT  (2026-10-07, Rishi: "I would also like the image gallery to peek on mobile just like the
   collection pages.")
   ----------------------------------------------------------------------------
   The collection grid's swipe hint (assets/r-card-carousel.js, hint(); 2026-09-25), on the product page's photo gallery: once,
   when the page loads, the photos slide a quarter of the width to the left, far enough to show the edge of photo 2, hold, and
   slide back (1.4 s, the cards' own keyframes: r-custom.css "THE SWIPE HINT" + "PDP GALLERY SWIPE HINT"). Same rules as the
   cards, so the two read as one behaviour:
   - phones and tablets (max-width 999px, where the gallery is the swipe carousel) on touch screens, never under reduced
     motion; a CSS animation on the slides' `transform`, NOT a scroll: no scroll event fires, so the progress line, the pinch
     zoom and the carousel's own scroll handling never run for it;
   - only with 2+ photos, once photo 2 has loaded (never a blank peek; 4 s to arrive, or no hint), 0.6 s after the gallery is
     on screen (60% of it, or of the screen), only if it is STILL on screen then, the page is visible, nothing (a drawer,
     the menu) covers its centre, no finger is on it and the photos are still on photo 1;
   - ON EVERY PAGE LOAD (2026-10-08, Rishi after speaking with Delinda: "I would also like the peek to happen on every refresh").
     It was once per visit (sessionStorage `r-gal-hint-shown`); that memory is gone. A touch on the gallery or any move off
     photo 1 still cancels it for this page.
   ============================================================================ */
(() => {
  const mq = window.matchMedia("(max-width: 999px)");
  const touchScreen = window.matchMedia("(hover: none), (pointer: coarse)");
  if (!mq.matches || !touchScreen.matches || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!("IntersectionObserver" in window)) return;
  const c = document.querySelector(".shopify-section--main-product scroll-carousel");
  if (!c) return;
  const slides = [...c.querySelectorAll(".product-gallery__media")].filter((s) => !s.hidden);
  if (slides.length < 2) return;
  const img = slides[1].querySelector("img");
  if (!img) return; // photo 2 is a video or 3D model: no peek

  let visible = false;
  let ready = false;
  let ended = false;
  let touching = false;
  let timer = 0;
  const finish = () => {
    ended = true;
    clearTimeout(timer);
    seen.disconnect();
    c.removeEventListener("touchstart", onTouch);
    c.removeEventListener("scroll", onScroll);
    removeEventListener("pagehide", finish);
  };
  const onTouch = () => { touching = true; c.classList.remove("r-gal-hint"); finish(); };
  const onScroll = () => { if (c.scrollLeft > 2) finish(); };
  const arm = () => {
    clearTimeout(timer);
    if (!ended && visible && ready) timer = setTimeout(play, 600);
  };
  const play = () => {
    if (ended || touching) return;
    if (document.hidden) { document.addEventListener("visibilitychange", arm, { once: true }); return; }
    if (!visible || c.scrollLeft > 2 || !mq.matches) return;
    // Nothing may cover it: an IntersectionObserver ignores layers on top (the cards' hint once played under the Filters drawer).
    const r = c.getBoundingClientRect();
    const top = Math.max(r.top, 0);
    const bottom = Math.min(r.bottom, window.innerHeight);
    const hit = document.elementFromPoint(r.left + r.width / 2, (top + bottom) / 2);
    if (!hit || !c.contains(hit)) { timer = setTimeout(play, 600); return; }
    finish();
    c.classList.add("r-gal-hint");
    setTimeout(() => c.classList.remove("r-gal-hint"), 1600);
  };
  const seen = new IntersectionObserver((entries) => {
    const e = entries[entries.length - 1];
    const need = 0.6 * Math.min(e.boundingClientRect.height, window.innerHeight);
    visible = e.isIntersecting && e.intersectionRect.height >= need;
    if (visible) arm();
    else clearTimeout(timer);
  }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });

  c.addEventListener("touchstart", onTouch, { passive: true });
  c.addEventListener("scroll", onScroll, { passive: true });
  addEventListener("pagehide", finish);
  seen.observe(c);

  const loaded = () => img.complete && img.naturalWidth > 0;
  if (loaded()) {
    ready = true;
  } else {
    if (img.loading === "lazy") img.loading = "eager";
    Promise.race([
      new Promise((resolve) => { img.addEventListener("load", resolve, { once: true }); img.addEventListener("error", resolve, { once: true }); }),
      new Promise((resolve) => setTimeout(resolve, 4000)),
    ]).then(() => {
      ready = loaded();
      if (ready) arm();
      else finish(); // photo 2 failed or took over 4 s: no hint on this page (never a blank peek)
    });
  }
})();

/* ============================================================================
   STICKY BAR HEIGHT FOR THE CHAT BUBBLE  (2026-10-07, Rishi: "Pls move the chat")
   The phone product page's chat bubble sits 8px above the sticky Add to Cart bar (r-custom.css "THE CHAT BUBBLE SITS JUST ABOVE
   THE STICKY BAR"). The bar's height changes (its brand/price rows fold away once the page's own copy is on screen; the PayPal line
   arrives late), so its height is written to `--r-bar-h` on <html> whenever it changes. Read-only for everything else; desktop's bar
   is display:none, so it writes 0 there, which nothing reads.
   ============================================================================ */
(() => {
  const bar = document.querySelector("product-sticky-add-to-cart");
  if (!bar || !("ResizeObserver" in window)) return;
  let last = -1;
  const set = () => {
    const h = Math.round(bar.getBoundingClientRect().height);
    if (h === last) return;
    last = h;
    document.documentElement.style.setProperty("--r-bar-h", h + "px");
  };
  new ResizeObserver(set).observe(bar);
  set();
})();

/* ============================================================================
   A SECOND TAP ON ADD TO CART MUST NOT OPEN CHECKOUT  (fix 2026-10-08, C-40; found in the freeze investigation, real iPhone)
   On the phone the sticky bar's Add to Cart and the cart drawer's CHECKOUT are the same button-sized spot at the bottom of the
   screen (430px wide: both 390x41 at y 647-650). An add opens the drawer (theme.js CartDrawer, on the `cart:change` whose
   `baseEvent` is "variant:add") and its content slides in under the finger, so a second tap meant for Add to Cart (a double
   tap on a fast connection, or a re-tap because nothing seemed to happen) landed on CHECKOUT and opened the checkout page:
   measured from 385 to 635 ms after the drawer started to open. A tap while the add request is in flight is already ignored
   (aria-busy, theme.js ProductForm; it is lifted before the follow-up /cart.js read, and a tap in that gap adds a second time:
   a separate bug, not handled here). So for 700 ms after an add, a click on the drawer's checkout button is dropped (the open
   animation itself takes 550 ms); after that a deliberate tap checks out as before. Capture phase on document, so it runs
   before the cart form submits. Checkout only: the drawer's other controls (close, quantities, recommendations) are untouched.
   ============================================================================ */
(() => {
  const HOLD_MS = 700;
  let heldUntil = 0;
  document.addEventListener("cart:change", (event) => {
    if (event.detail?.baseEvent === "variant:add") heldUntil = performance.now() + HOLD_MS;
  });
  document.addEventListener("click", (event) => {
    if (performance.now() >= heldUntil) return;
    if (!event.target.closest?.('cart-drawer [name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();

/* ============================================================================
   BREADCRUMBS: ONE SWIPEABLE LINE  (2026-10-07, Rishi: "I cannot have the breadcrumbs wrapping. Is there a clever way to have these
   stay complete but on a single line?")
   Below 1000px the trail under the header is a single line that scrolls sideways (r-custom.css "BREADCRUMBS ON ONE LINE ON THE
   PHONE"). This opens it at the END (the most specific rungs are what shows; home and the gender are a swipe to the left) and keeps
   two classes current for the edge fades: `r-crumbs--more-start` when something is hidden on the left, `r-crumbs--more-end` on the
   right. Re-run once the webfont lands (it changes the widths) and on a change of width. Desktop: the classes stay off (it wraps).
   ============================================================================ */
(() => {
  const mq = window.matchMedia("(max-width: 999px)");
  const lists = () => document.querySelectorAll(".r-crumbs-top .r-breadcrumbs");
  const sync = (ol) => {
    const max = ol.scrollWidth - ol.clientWidth;
    const on = mq.matches && max > 4; // a few px of overhang (the home icon's widened tap area) is not "more": no fade
    ol.classList.toggle("r-crumbs--more-start", on && ol.scrollLeft > 1);
    ol.classList.toggle("r-crumbs--more-end", on && ol.scrollLeft < max - 1);
  };
  const init = () => {
    lists().forEach((ol) => {
      if (!ol.dataset.rCrumbScroll) {
        ol.dataset.rCrumbScroll = "1";
        ol.addEventListener("scroll", () => sync(ol), { passive: true });
      }
      if (mq.matches && ol.scrollWidth - ol.clientWidth > 4) ol.scrollLeft = ol.scrollWidth;
      sync(ol);
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
  mq.addEventListener("change", init);
  window.addEventListener("resize", () => lists().forEach(sync), { passive: true });
})();

/* ============================================================================
   STICKY BREADCRUMBS: HEIGHT  (2026-10-07, Rishi: "is it possible to make the breadcrumbs stick to the header?")
   Below 1000px the breadcrumb bar pins under the header (r-custom.css "THE BREADCRUMBS STICK UNDER THE HEADER"). Its height, which
   differs by page type (14px under it on product, article and 404 pages) and can change with the webfont, is written to
   `--r-crumbs-sticky-h` on <html> so the filter bar and anchor jumps clear it. 0px from 1000px (it doesn't stick there) and on pages
   without a bar.
   ============================================================================ */
(() => {
  const bar = document.querySelector(".r-crumbs-top");
  const mq = window.matchMedia("(max-width: 999px)");
  const root = document.documentElement;
  let last = "";
  const set = () => {
    /* also from 1000px on product pages, where the bar now pins too (2026-10-16): whenever it is actually sticky */
    const h = bar && (mq.matches || getComputedStyle(bar).position === "sticky") ? Math.round(bar.getBoundingClientRect().height * 10) / 10 : 0;
    const v = h + "px";
    if (v === last) return;
    last = v;
    root.style.setProperty("--r-crumbs-sticky-h", v);
  };
  /* border-box: the pinned state changes only the PADDING, which a default (content-box) observer never reports */
  if (bar && "ResizeObserver" in window) new ResizeObserver(set).observe(bar, { box: "border-box" });
  mq.addEventListener("change", set);
  set();

  /* PINNED = TIGHTER (same day, Rishi: "tighten the breadcrumb padding when pinned"): the bar sits right under the sticky header, so it
     is pinned as soon as the page has scrolled at all. One class, set in a rAF; r-custom.css "TIGHTER WHEN PINNED" does the rest. */
  if (bar) {
    let queued = false;
    const pin = () => {
      queued = false;
      bar.classList.toggle("r-crumbs-pinned", mq.matches && window.scrollY > 0);
      set();
    };
    window.addEventListener("scroll", () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(pin);
    }, { passive: true });
    mq.addEventListener("change", pin);
    pin();
  }
})();

/* "Chat now" (2026-10-09, Rishi: "can you add a button to the contact us page that will invoke the chat"): any link to
   #chat opens the Gorgias chat window. Today that's the button under "Chat With Us" on /pages/contact-us
   (templates/page.contact.json). Copy-verifier review, same day:
   - it opens the chat rather than a page, so it gets role="button" and the Space key;
   - waits are short: up to 2 s for the Gorgias bundle (window.GorgiasChat) and 2.5 s for init(). If chat never
     arrives (ad blocker, failed load), or open() leaves no open window, it falls back to email, so it's never a dead click. */
(() => {
  const FALLBACK = "mailto:help@dihsan.com";
  const SEL = 'a[href="#chat"]';
  const ready = () => new Promise((resolve, reject) => {
    const t0 = Date.now();
    (function wait() {
      const gc = window.GorgiasChat;
      if (gc && typeof gc.init === "function" && typeof gc.open === "function") return resolve(gc);
      if (Date.now() - t0 > 2000) return reject(new Error("no GorgiasChat"));
      setTimeout(wait, 100);
    })();
  });
  const withTimeout = (p, ms) => Promise.race([p, new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), ms))]);
  const openChat = () => ready()
    .then((gc) => withTimeout(Promise.resolve(gc.init()), 2500).then(() => {
      gc.open();
      if (typeof gc.isOpen === "function") {
        setTimeout(() => { if (!gc.isOpen()) window.location.href = FALLBACK; }, 800);
      }
    }))
    .catch(() => { window.location.href = FALLBACK; });
  // A plain text link, styled like the page's other links (Rishi, same day: "I don't want a button. just a text link
  // like the rest of the page"). role="button" because it opens the chat rather than going to a page.
  const mark = () => document.querySelectorAll(SEL).forEach((a) => a.setAttribute("role", "button"));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mark); else mark();
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest(SEL);
    if (!a) return;
    e.preventDefault();
    openChat();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== " " && e.key !== "Spacebar") return;
    const a = e.target.closest && e.target.closest(SEL);
    if (!a) return;
    e.preventDefault();
    openChat();
  });
})();
